/* ==========================================================================
   CLAYDALE — interacciones
   Todo vanilla. Una función init por componente, todas seguras si su
   elemento no existe. Respeta prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  // Cada sección incluye este archivo y el navegador lo ejecuta una vez por
  // etiqueta <script>. Sin este cerrojo, los escuchadores se duplican y los
  // acordeones se abren y cierran en el mismo clic (parece que no funcionan).
  if (window.__cdArrancado) return;
  window.__cdArrancado = true;

  var menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Entradas al hacer scroll ------------------------------------------ */

  /* Devuelve el carrusel horizontal en el que vive un elemento, si es que vive
     en uno. Se mira el overflow de verdad, no la clase, para que valga con
     cualquier tira que se añada más adelante. */
  function carruselDe(el) {
    var n = el.parentElement;
    while (n && n !== document.body) {
      var ox = getComputedStyle(n).overflowX;
      if (ox === 'auto' || ox === 'scroll') return n;
      n = n.parentElement;
    }
    return null;
  }

  function initReveals() {
    /* Deja constancia de que el motor de animaciones ha arrancado. Lo mira la
       red de seguridad de `theme.liquid`: si a los 4 s esto no está puesto, es
       que este fichero no ha llegado o ha reventado antes, y destapa todo. */
    window.__cdRevealsVivo = true;
    var elems = document.querySelectorAll('.cd-reveal, .cd-reveal-img, .cd-lineas');
    if (!elems.length) return;

    if (menosMovimiento || !('IntersectionObserver' in window)) {
      elems.forEach(function (el) { el.classList.add('cd-visible'); });
      return;
    }

    var opciones = { threshold: 0.14, rootMargin: '0px 0px -8% 0px' };

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('cd-visible');
        obs.unobserve(e.target);
      });
    }, opciones);

    /* Lo que vive dentro de un carrusel horizontal NO se ata a su propia
       posición: lo que está a la derecha, fuera de la pantalla, se quedaría
       invisible y bajado 26 px, y al arrastrar subiría de golpe delante de los
       ojos —los iconos de "¿Qué buscas hoy?" y las fichas de las filas—. Se
       observa el carrusel entero y, cuando entra, se revela todo lo suyo de
       una vez. El escalonado de retardos sigue funcionando igual. */
    var grupos = [];
    var carruseles = [];

    Array.prototype.forEach.call(elems, function (el) {
      var car = carruselDe(el);
      if (!car) { obs.observe(el); return; }
      var i = carruseles.indexOf(car);
      if (i === -1) { carruseles.push(car); grupos.push([el]); }
      else { grupos[i].push(el); }
    });

    if (!carruseles.length) return;

    var obsGrupo = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = carruseles.indexOf(e.target);
        if (i !== -1) {
          grupos[i].forEach(function (el) { el.classList.add('cd-visible'); });
        }
        obsGrupo.unobserve(e.target);
      });
    }, opciones);

    carruseles.forEach(function (car) { obsGrupo.observe(car); });
  }

  /* --- Titulares que entran línea a línea --------------------------------- */
  function initLineas() {
    document.querySelectorAll('.cd-lineas').forEach(function (cont) {
      var masks = cont.querySelectorAll('.cd-linea-mask > span');
      masks.forEach(function (span, i) {
        span.style.setProperty('--cd-delay', (i * 90) + 'ms');
      });
    });
  }

  /* --- Escalonado genérico de reveals dentro de un contenedor ------------- */
  function initStagger() {
    document.querySelectorAll('[data-cd-stagger]').forEach(function (cont) {
      var paso = parseInt(cont.getAttribute('data-cd-stagger'), 10) || 110;
      cont.querySelectorAll('.cd-reveal, .cd-reveal-img').forEach(function (el, i) {
        el.style.setProperty('--cd-delay', (i * paso) + 'ms');
      });
    });
  }

  /* --- Parallax suave (solo transform) ------------------------------------ */
  function initParallax() {
    if (menosMovimiento) return;
    if (!document.querySelectorAll('[data-cd-parallax]').length) return;

    /* La lista se lee EN CADA PINTADA, no una vez al arrancar. Antes se
       capturaba aquí, así que en el editor de temas —donde `arranca()` se
       vuelve a lanzar en cada recarga de sección— cada pasada dejaba un
       escuchador nuevo con su propia lista congelada: el parallax se
       recalculaba varias veces por scroll. Ahora el escuchador se ata UNA vez
       y siempre mira los elementos que hay de verdad. 9 sept 2026.        */
    var pendiente = false;

    function pinta() {
      pendiente = false;
      var vh = window.innerHeight;
      document.querySelectorAll('[data-cd-parallax]').forEach(function (capa) {
        var cont = capa.parentElement;
        var r = cont.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var fuerza = parseFloat(capa.getAttribute('data-cd-parallax')) || 8;
        // -1 arriba del todo, +1 abajo del todo
        var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        capa.style.transform = 'translate3d(0,' + (p * fuerza).toFixed(2) + '%,0)';
      });
    }

    function alScroll() {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(pinta);
    }

    if (!document.__cdParallax) {
      document.__cdParallax = true;
      window.addEventListener('scroll', alScroll, { passive: true });
      window.addEventListener('resize', alScroll, { passive: true });
    }
    pinta();
  }

  /* --- Cabecera: sombra al bajar + menú móvil ----------------------------- */
  function initHeader() {
    var hd = document.querySelector('.cd-hd');
    if (hd) {
      var marca = function () {
        var actual = document.querySelector('.cd-hd');
        if (actual) actual.classList.toggle('cd-hd--scroll', window.scrollY > 8);
      };
      // Altura real de las dos barras de arriba, para que en móvil la cabecera
      // se pegue con un `top` negativo y solo quede fijo el logo (cd-styles.css).
      var mideBarras = function () {
        var alto = 0;
        ['.cd-aviso-controles', '.cd-promo'].forEach(function (sel) {
          var el = document.querySelector(sel);
          if (el && !el.hidden) alto += el.offsetHeight;
        });
        if (alto > 0) document.documentElement.style.setProperty('--cd-barras', alto + 'px');
      };
      if (!document.__cdMideBarras) {
        document.__cdMideBarras = true;
        window.addEventListener('resize', mideBarras, { passive: true });
        window.addEventListener('load', mideBarras);
      }
      mideBarras();
      if (!document.__cdHeaderScroll) {
        document.__cdHeaderScroll = true;
        window.addEventListener('scroll', marca, { passive: true });
      }
      marca();
    }
    var abrir = document.querySelector('[data-cd-abrir-menu]');
    var menu = document.getElementById('cd-menu');
    if (!abrir || !menu || menu.__cdMenuAtado) return;
    menu.__cdMenuAtado = true;
    var previoOverflow = '';
    function cierra(devolver) {
      if (!menu.classList.contains('cd-abierto')) return;
      menu.classList.remove('cd-abierto');
      document.documentElement.classList.remove('cd-menu-abierto');
      menu.setAttribute('aria-hidden', 'true');
      menu.inert = true;
      abrir.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = previoOverflow;
      if (devolver !== false) abrir.focus();
    }
    abrir.addEventListener('click', function () {
      previoOverflow = document.body.style.overflow;
      menu.inert = false;
      menu.classList.add('cd-abierto');
      // 15 oct 2026: con esta clase la cabecera sube por encima de la barra fija de compra (ver cd2-styles.css).
      document.documentElement.classList.add('cd-menu-abierto');
      menu.setAttribute('aria-hidden', 'false');
      abrir.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var primero = menu.querySelector('button, a[href]');
      if (primero) primero.focus();
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('[data-cd-cerrar-menu]')) cierra();
      else if (e.target.closest('a')) cierra(false);
    });
    menu.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); cierra(); return; }
      if (e.key !== 'Tab') return;
      var items = Array.from(menu.querySelectorAll('a[href], button, summary, input, [tabindex="0"]'))
        .filter(function (el) { return !el.disabled && el.getClientRects().length; });
      var primero = items[0], ultimo = items[items.length - 1];
      if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) cierra(); });
    window.matchMedia('(min-width:990px)').addEventListener('change', function (e) { if (e.matches) cierra(false); });
  }

  /* --- Selector de tonos: tiñe la sección --------------------------------- */
  function initTonos() {
    document.querySelectorAll('[data-cd-tonos]').forEach(function (sec) {
      var botones = sec.querySelectorAll('.cd-tono');
      var tinte = sec.querySelector('.cd-tonos__tinte');
      var foco = sec.querySelector('[data-cd-foco]');
      if (!botones.length) return;

      function elige(btn) {
        botones.forEach(function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
        var color = btn.getAttribute('data-cd-color');
        if (tinte && color) tinte.style.backgroundColor = color;
        // el foco se mueve al manchón de ese tono dentro de la foto
        var x = btn.getAttribute('data-cd-swatch');
        if (foco && x) foco.style.left = x + '%';
        sec.classList.add('cd-tono-activo');
      }

      botones.forEach(function (btn) {
        btn.addEventListener('click', function () { elige(btn); });
        btn.addEventListener('mouseenter', function () { elige(btn); });
      });
      elige(botones[0]);
    });
  }

  /* --- Escena sticky: la foto cambia según el capítulo -------------------- */
  function initEscena() {
    document.querySelectorAll('[data-cd-escena]').forEach(function (sec) {
      var caps = sec.querySelectorAll('.cd-escena__cap');
      var fotos = sec.querySelectorAll('.cd-escena__foto');
      if (!caps.length || !fotos.length) return;

      function activa(i) {
        fotos.forEach(function (f, j) { f.classList.toggle('cd-act', j === i); });
      }
      activa(0);

      if (!('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = parseInt(e.target.getAttribute('data-cd-cap'), 10);
          if (!isNaN(i)) activa(i);
        });
      }, { threshold: 0.5, rootMargin: '-20% 0px -20% 0px' });

      caps.forEach(function (c) { obs.observe(c); });
    });
  }

  /* --- Acordeones (preguntas y ficha) ------------------------------------- */
  function initAcordeones() {
    document.querySelectorAll('[data-cd-acordeon]').forEach(function (lista) {
      var unoSolo = lista.getAttribute('data-cd-acordeon') === 'uno';
      lista.querySelectorAll('[data-cd-acc-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.cd-faq__it, .cd-acc__it');
          if (!item) return;
          var abierto = item.classList.contains('cd-abierto');
          if (unoSolo) {
            lista.querySelectorAll('.cd-abierto').forEach(function (o) {
              o.classList.remove('cd-abierto');
              var b = o.querySelector('[data-cd-acc-btn]');
              if (b) b.setAttribute('aria-expanded', 'false');
            });
          }
          item.classList.toggle('cd-abierto', !abierto);
          btn.setAttribute('aria-expanded', String(!abierto));
        });
      });
    });
  }

  /* --- Cifras que cuentan hacia arriba ------------------------------------ */
  function initCifras() {
    /* Solo cuentan los que TRAEN un número en el atributo. La burbuja del
       carrito llevaba `data-cd-cuenta` sin valor y entraba aquí: el atributo
       vacío daba NaN y esta función escribía '' dentro de la burbuja, o sea
       que borraba el número del carrito en cada carga de página. Con «reducir
       movimiento» el borrado era inmediato y definitivo. Ahora la burbuja se
       llama `data-cd-carrito` y, por si acaso, aquí también se filtra.
       Cazado el 9 sept 2026.                                               */
    var todas = document.querySelectorAll('[data-cd-cuenta]');
    var cifras = [];
    Array.prototype.forEach.call(todas, function (el) {
      var v = (el.getAttribute('data-cd-cuenta') || '').trim();
      if (v !== '') { cifras.push(el); }
    });
    if (!cifras.length) return;

    if (menosMovimiento || !('IntersectionObserver' in window)) {
      cifras.forEach(function (el) { el.textContent = el.getAttribute('data-cd-cuenta'); });
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        obs.unobserve(el);
        var bruto = el.getAttribute('data-cd-cuenta') || '';
        var num = parseFloat(bruto.replace(',', '.').replace(/[^\d.]/g, ''));
        if (isNaN(num)) { el.textContent = bruto; return; }
        var decimales = (bruto.split(/[.,]/)[1] || '').length;
        var sep = bruto.indexOf(',') > -1 ? ',' : '.';
        var pre = bruto.slice(0, bruto.search(/[\d]/));
        var post = bruto.slice(bruto.search(/[\d][^\d.,]*$/) + 1).replace(/^[\d]/, '');
        var t0 = null;
        var dur = 1400;
        function paso(t) {
          if (t0 === null) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          var suave = 1 - Math.pow(1 - p, 3);
          var v = (num * suave).toFixed(decimales);
          if (sep === ',') v = v.replace('.', ',');
          el.textContent = pre + v + post;
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.6 });

    cifras.forEach(function (el) { obs.observe(el); });
  }

  /* --- Galería de la ficha de producto ------------------------------------ */
  function initGaleria() {
    var gal = document.querySelector('[data-cd-galeria]');
    if (!gal) return;
    var fotos = gal.querySelectorAll('.cd-gal__foto');
    var minis = gal.querySelectorAll('.cd-gal__mini');
    var ant = gal.querySelector('[data-cd-gal-ant]');
    var sig = gal.querySelector('[data-cd-gal-sig]');
    var cuenta = gal.querySelector('[data-cd-gal-cuenta]');
    if (!fotos.length) return;

    var actual = 0;

    function muestra(i) {
      // da la vuelta por los dos lados
      actual = (i + fotos.length) % fotos.length;
      fotos.forEach(function (f, j) { f.classList.toggle('cd-act', j === actual); });
      minis.forEach(function (m, j) { m.setAttribute('aria-current', j === actual ? 'true' : 'false'); });
      if (cuenta) cuenta.textContent = (actual + 1) + ' / ' + fotos.length;

      // que la miniatura activa quede a la vista
      var mini = minis[actual];
      if (mini && mini.scrollIntoView) {
        mini.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    minis.forEach(function (m, i) {
      m.addEventListener('click', function () { muestra(i); });
    });
    if (ant) ant.addEventListener('click', function () { muestra(actual - 1); });
    if (sig) sig.addEventListener('click', function () { muestra(actual + 1); });

    // flechas del teclado cuando la galería tiene el foco dentro
    gal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { muestra(actual - 1); }
      else if (e.key === 'ArrowRight') { muestra(actual + 1); }
    });

    // arrastrar en móvil
    var x0 = null;
    var ppal = gal.querySelector('.cd-gal__ppal');
    if (ppal) {
      ppal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      ppal.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) muestra(dx < 0 ? actual + 1 : actual - 1);
        x0 = null;
      }, { passive: true });
    }

    muestra(0);

    gal.cdMuestraPorMedia = function (id) {
      var idx = -1;
      fotos.forEach(function (f, j) {
        if (String(f.getAttribute('data-media-id')) === String(id)) idx = j;
      });
      if (idx > -1) muestra(idx);
    };
  }

  /* --- Selector de packs de la ficha --------------------------------------
     Los packs son CANTIDADES del mismo producto (el proveedor solo tiene una
     referencia), así que lo que cambia es el campo "quantity", no el "id".   */
  function initPacks() {
    var form = document.querySelector('[data-cd-form]');
    if (!form) return;
    var packs = form.querySelectorAll('.cd-pack');
    var campoCant = form.querySelector('[data-cd-cantidad]');
    var boton = form.querySelector('[data-cd-anadir]');
    var ahora = document.querySelector('[data-cd-precio-ahora]');
    var antes = document.querySelector('[data-cd-precio-antes]');
    if (!packs.length || !campoCant) return;

    /* 20 sept 2026 · Opciones «complétalo»: son OTRO producto (un pack de la
       tienda), así que además de la cantidad cambia el "id". El id de partida
       se guarda una vez para poder volver a él al elegir 1, 2 o 3 unidades.   */
    var campoId = form.querySelector('input[name="id"]');
    var idBase = campoId ? campoId.value : '';

    function elige(btn) {
      packs.forEach(function (p) { p.setAttribute('aria-checked', p === btn ? 'true' : 'false'); });
      campoCant.value = btn.getAttribute('data-cd-cant') || '1';
      if (campoId) campoId.value = btn.getAttribute('data-cd-variante') || idBase;
      // «Tu segundo producto» no tiene sentido con un pack, que ya trae su precio.
      var seg = form.querySelector('[data-cd-segundo]');
      if (seg) {
        var esCombo = !!btn.getAttribute('data-cd-variante');
        seg.hidden = esCombo;
        if (esCombo) seg.querySelectorAll('[data-cd-segundo-op]').forEach(function (c) { c.checked = false; });
      }

      if (ahora) ahora.textContent = btn.getAttribute('data-cd-precio') || ahora.textContent;
      if (antes) {
        var ant = btn.getAttribute('data-cd-antes');
        antes.textContent = ant || '';
        antes.style.display = ant ? '' : 'none';
      }

      var agotado = btn.getAttribute('data-cd-disponible') === 'false';
      if (boton) {
        boton.disabled = agotado;
        boton.textContent = agotado
          ? (boton.getAttribute('data-cd-agotado') || 'Agotado')
          : (boton.getAttribute('data-cd-texto') || 'Añadir al carrito');
      }

      // La barra fija enseña el mismo precio y el mismo estado que el botón real
      var bAhora = document.querySelector('[data-cd-barra-ahora]');
      var bAntes = document.querySelector('[data-cd-barra-antes]');
      var bBoton = document.querySelector('[data-cd-barra-btn]');
      if (bAhora) bAhora.textContent = btn.getAttribute('data-cd-precio') || bAhora.textContent;
      if (bAntes) {
        var bAnt = btn.getAttribute('data-cd-antes');
        bAntes.textContent = bAnt || '';
        bAntes.style.display = bAnt ? '' : 'none';
      }
      if (bBoton && boton) {
        bBoton.disabled = agotado;
        bBoton.textContent = boton.textContent;
      }
    }

    /* «Tu segundo producto»: la cuenta de lo que se paga con lo marcado, igual
       que la hace Shopify: 15 % con dos productos y 25 % con tres o más (al principal
       se le deja su escalón de unidades si es mejor), y al total se le quita el
       general, truncado al céntimo. Tiene que coincidir con la cesta.           */
    function centimos(txt) { var n = String(txt || '').replace(/[^0-9]/g, ''); return n ? parseInt(n, 10) : 0; }
    function euros(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
    function segundoTotal() {
      var seg = form.querySelector('[data-cd-segundo]');
      if (!seg) return;
      var salida = seg.querySelector('[data-cd-segundo-total]');
      if (!salida) return;
      var marcados = Array.prototype.slice.call(seg.querySelectorAll('[data-cd-segundo-op]:checked'));
      // El botón dice cuántos productos mete, para que nadie dude de si lo marcado va en la cesta.
      if (boton && !boton.disabled) {
        var elegidoBtn = form.querySelector('.cd-pack[aria-checked="true"]');
        var unidades = elegidoBtn ? parseInt(elegidoBtn.getAttribute('data-cd-cant') || '1', 10) : 1;
        boton.textContent = (!seg.hidden && marcados.length)
          ? 'Añadir los ' + (unidades + marcados.length) + ' a la cesta'
          : (boton.getAttribute('data-cd-texto') || 'Añadir a la cesta');
      }
      if (seg.hidden || !marcados.length) { salida.hidden = true; salida.textContent = ''; return; }
      var pct2 = parseFloat(seg.getAttribute('data-pct')) || 0;
      var pct3 = parseFloat(seg.getAttribute('data-pct3')) || pct2;
      var general = parseFloat(seg.getAttribute('data-pct-general')) || 0;
      var elegido = form.querySelector('.cd-pack[aria-checked="true"]');
      var cant = elegido ? parseInt(elegido.getAttribute('data-cd-cant') || '1', 10) : 1;
      var unidad = parseInt(seg.getAttribute('data-precio-base') || '0', 10);
      var escalon = elegido ? centimos(elegido.getAttribute('data-cd-precio')) : unidad * cant;
      var cuantos = cant + marcados.length;
      // 2 productos → pct2; 3 o más → pct3. Shopify quita el porcentaje POR UNIDAD y trunca el céntimo.
      var pct = cuantos >= 3 ? pct3 : pct2;
      var rebaja = function (c) { return c - Math.floor(c * pct / 100); };
      // Al principal se le aplica lo mejor para el cliente: su escalón de unidades o este porcentaje.
      var total = Math.min(escalon || unidad * cant, rebaja(unidad) * cant);
      marcados.forEach(function (c) { total += rebaja(parseInt(c.getAttribute('data-precio') || '0', 10)); });
      var paga = total - Math.floor(total * general / 100);
      salida.innerHTML = 'Tus ' + cuantos + ' productos: ' + euros(total) +
        (general > 0 ? ' · con el ' + general + ' % de la web pagas <strong>' + euros(paga) + '</strong>' : '');
      salida.hidden = false;
    }
    form.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-cd-segundo-op')) segundoTotal();
    });

    packs.forEach(function (p) {
      p.addEventListener('click', function () { elige(p); segundoTotal(); });
    });

    var inicial = form.querySelector('.cd-pack[aria-checked="true"]') || packs[0];
    elige(inicial);
  }

  /* --- Compra simplificada (1 oct 2026, hoy solo la ficha del bálsamo) ------
     Unidades + UNA casilla para sumar otro producto. Con 1 unidad la casilla
     cambia el "id" del formulario al PACK que ya los lleva juntos (sale más
     barato que sueltos); con 2 o 3 deja el producto y mete el otro al lado
     (lo recoge el envío del formulario en initCesta). Como en las filas, el
     precio grande va SIN el general y debajo, en rojo, «Con el 15 %: …»; la
     casilla dice cuánto suma, tachado el precio suelto y por qué baja (Joni:
     «no queda claro de dónde salen»). Las cuentas son las de segundoTotal():
     porcentaje por línea truncado al céntimo y el general sobre el total,
     truncado también. Comprobado con cestas reales.                       */
  function initCompraSimple() {
    var form = document.querySelector('[data-cd-form]');
    var boton = form && form.querySelector('[data-cd-anadir]');
    if (!form || !boton) return;
    if (!form.querySelector('[data-cd-simple]')) return;   // solo en las fichas con la compra simplificada
    var caja = form.querySelector('[data-cd-extra]');
    var chk = caja ? caja.querySelector('[data-cd-extra-op]') : null;
    var suma = caja ? caja.querySelector('[data-cd-extra-suma]') : null;
    var sumaFinal = caja ? caja.querySelector('[data-cd-extra-final]') : null;
    var porque = caja ? caja.querySelector('[data-cd-extra-porque]') : null;
    var campoId = form.querySelector('input[name="id"]');
    var idBase = campoId ? campoId.value : '';
    var ahora = document.querySelector('[data-cd-precio-ahora]');
    var antes = document.querySelector('[data-cd-precio-antes]');
    var final = document.querySelector('[data-cd-precio-final]');
    var bAhora = document.querySelector('[data-cd-barra-ahora]');
    var bAntes = document.querySelector('[data-cd-barra-antes]');
    var bBoton = document.querySelector('[data-cd-barra-btn]');
    var texto = boton.getAttribute('data-cd-texto') || 'Añadir a la cesta';
    var dato = function (n) { return caja ? parseInt(caja.getAttribute(n) || '0', 10) || 0 : 0; };
    var pct2 = dato('data-pct'), pct3 = dato('data-pct3') || dato('data-pct');
    var base = dato('data-precio-base'), extra = dato('data-precio-extra');
    var packId = caja ? caja.getAttribute('data-pack-variante') : null, packPrecio = dato('data-pack-precio');
    var textoFinal = (caja && caja.getAttribute('data-texto-final')) || 'Precio final: [precio]';
    var porquePack = caja ? caja.getAttribute('data-porque-pack') || '' : '';
    var porqueSuelto = caja ? caja.getAttribute('data-porque-suelto') || '' : '';
    /* El general sale SOLO del ajuste de la ficha (`pct_general`, que llega en la casilla).
       11 oct 2026: antes, con el ajuste a 0, se sacaba el número del texto «Con el 15 %: [precio]»
       y el botón del bálsamo restaba un 15 % que ya no existe: decía 21,21 € y se cobraban 24,95 €,
       y en la bruma salía «Con el 15 %: +5,99 €». Sin ajuste, 0.                              */
    var general = dato('data-pct-general');
    function euros(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
    function menos(c, pct) { return c - Math.floor(c * pct / 100); }
    function conExtra(cant, escalon) {   // lo que vale con el otro producto, ANTES del general
      if (cant === 1 && packId && packPrecio) return packPrecio;
      var pct = cant + 1 >= 3 ? pct3 : pct2;
      return Math.min(escalon, menos(base, pct) * cant) + menos(extra, pct);
    }
    function pinta() {
      var el = form.querySelector('.cd-pack[aria-checked="true"]');
      var cant = el ? parseInt(el.getAttribute('data-cd-cant') || '1', 10) : 1;
      var escalon = el ? parseInt(el.getAttribute('data-cd-escalon') || '0', 10) : 0;
      if (!escalon) escalon = base * cant;
      var marcado = !!(chk && chk.checked);
      var con = caja ? conExtra(cant, escalon) : escalon;
      var bruto = marcado ? con : escalon;
      var paga = menos(bruto, general);
      if (caja) {
        if (suma) suma.textContent = '+' + euros(con - escalon);
        if (sumaFinal) {
          // 8 oct 2026 · Sin descuento general el «+X» de arriba ya es lo que se paga: fuera la línea roja.
          sumaFinal.hidden = !(general > 0);
          sumaFinal.textContent = general > 0 ? textoFinal.replace('[precio]', '+' + euros(menos(con, general) - menos(escalon, general))) : '';
        }
        if (porque) porque.textContent = (cant === 1 && packId) ? porquePack : (cant + 1 >= 3 ? porqueSuelto : '');
      }
      // Con 1 unidad y la casilla marcada va el pack; si no, el producto (y la casilla, aparte).
      var conPack = marcado && cant === 1 && !!packId;
      if (campoId) campoId.value = conPack ? packId : idBase;
      if (chk) {
        if (conPack) chk.setAttribute('data-cd-extra-en-pack', '');
        else chk.removeAttribute('data-cd-extra-en-pack');
      }
      var ant = (!marcado && el) ? (el.getAttribute('data-cd-antes') || '') : '';
      [[ahora, antes], [bAhora, bAntes]].forEach(function (par) {
        if (par[0]) par[0].textContent = euros(bruto);
        if (par[1]) { par[1].textContent = ant; par[1].style.display = ant ? '' : 'none'; }
      });
      if (final && general > 0) final.textContent = textoFinal.replace('[precio]', euros(paga));
      if (!boton.disabled) boton.textContent = texto + ' · ' + euros(paga);
      if (bBoton && !bBoton.disabled) bBoton.textContent = texto;
    }
    form.addEventListener('change', function (e) { if (chk && e.target === chk) pinta(); });
    form.querySelectorAll('.cd-pack').forEach(function (p) { p.addEventListener('click', pinta); });
    pinta();
  }

  /* --- Barra fija de compra (móvil y escritorio) ---------------------------
     Aparece cuando el botón real ya ha quedado por encima de la pantalla, y se
     esconde otra vez al llegar al pie para no taparlo. El botón no añade nada
     por su cuenta: envía el formulario de arriba, así que hereda el pack
     elegido y el estado de agotado.                                          */
  function initBarraCompra() {
    var barra = document.querySelector('[data-cd-barra]');
    if (!barra) return;
    /* Marcada la barra antes de atarla. En el editor esta función se vuelve a
       lanzar en cada recarga de sección y dejaba otro par de escuchadores de
       scroll sobre la MISMA barra. 9 sept 2026.                            */
    if (barra.__cdAtada) return;
    barra.__cdAtada = true;
    var form = document.querySelector('[data-cd-form]');
    var botonReal = document.querySelector('[data-cd-anadir]');
    var botonBarra = barra.querySelector('[data-cd-barra-btn]');
    if (!form || !botonReal || !botonBarra) return;

    var visible = false;
    /* 1 oct 2026 · Con `data-cd-barra-pronto` (ficha del bálsamo) la barra sale
       en cuanto se baja un poco, no al pasar el botón (en el móvil estaba a
       2.500 px). Se esconde mientras se ve el botón de verdad, para no tener
       dos, y mientras está el aviso de cookies de Shopify, que va abajo.     */
    var pronto = barra.hasAttribute('data-cd-barra-pronto');
    /* 15 oct 2026 · Auditoría de la web (nº 2): en el MÓVIL la barra sale desde que se abre la ficha, como en
       Primor, porque al llegar del anuncio el precio y el botón quedaban por debajo de la primera pantalla.
       Se esconde solo mientras se ve el botón de verdad (para no tener dos) y, si está el aviso de cookies de
       Shopify, se coloca justo ENCIMA de él (no se tapa ni el aviso ni sus botones). En el ordenador, como antes. */
    var movil = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
    function altoAviso() {
      var b = document.getElementById('shopify-pc__banner');
      if (!b) return 0;
      var e = window.getComputedStyle(b);
      if (e.display === 'none' || e.visibility === 'hidden' || e.opacity === '0') return 0;
      var r = b.getBoundingClientRect();
      if (r.height <= 0 || r.bottom <= 0 || r.top >= window.innerHeight) return 0;
      return Math.max(0, Math.round(window.innerHeight - r.top));
    }
    function cookiesFuera() { return altoAviso() > 0; }

    function pinta(mostrar) {
      if (mostrar === visible) return;
      visible = mostrar;
      barra.classList.toggle('cd-barra--fuera', mostrar);
      barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
      botonBarra.tabIndex = mostrar ? 0 : -1;
    }

    function revisa() {
      var r = botonReal.getBoundingClientRect();
      if (movil.matches) {
        var aviso = altoAviso();
        barra.style.bottom = aviso ? aviso + 'px' : '';
        pinta(!(r.top < window.innerHeight - aviso && r.bottom > 0));
        return;
      }
      barra.style.bottom = '';
      var pasado = r.bottom < 0;               // el botón real ya no se ve
      // Antes se escondía al asomar el pie. Joni pidió que se quede hasta
      // abajo del todo, así que ya no se esconde: al pie se le reserva sitio
      // con el relleno de .cd2-con-barra (cd2-styles.css / cd2-scripts.js).
      if (pronto) {
        var seVe = r.top < window.innerHeight && r.bottom > 0;
        pinta(window.scrollY > 60 && !seVe && !cookiesFuera());
        return;
      }
      pinta(pasado);
    }
    // El aviso de cookies se cierra sin mover la página: se mira cada segundo mientras
    // exista y una vez más cuando desaparece, para que la barra vuelva a salir.
    var habiaAviso = false;
    if (pronto || movil.matches) window.setInterval(function () {
      var hay = !!document.getElementById('shopify-pc__banner');
      if (hay || habiaAviso) revisa();
      habiaAviso = hay;
    }, 1000);

    /* 15 oct 2026 · El −X % de la barra sigue a su precio y a su tachado, que cambian con las unidades. */
    var bPct = barra.querySelector('[data-cd-barra-pct]');
    var bAh = barra.querySelector('[data-cd-barra-ahora]');
    var bAn = barra.querySelector('[data-cd-barra-antes]');
    function cents(t) { var n = String(t || '').replace(/[^0-9]/g, ''); return n ? parseInt(n, 10) : 0; }
    function pctBarra() {
      if (!bPct || !bAh || !bAn) return;
      var a = cents(bAh.textContent), b = bAn.style.display === 'none' ? 0 : cents(bAn.textContent);
      var p = (b > a && a > 0) ? Math.round((b - a) * 100 / b) : 0;
      var t = '\u2212' + p + ' %';
      if (bPct.textContent !== t) bPct.textContent = t;
      bPct.hidden = !(p > 0);
    }
    if (bPct && bAh && bAn && window.MutationObserver) {
      var moPct = new MutationObserver(pctBarra);
      moPct.observe(bAh, { childList: true, characterData: true, subtree: true });
      moPct.observe(bAn, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['style'] });
      pctBarra();
    }

    botonBarra.addEventListener('click', function () {
      if (botonBarra.disabled) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(botonReal);
      else form.submit();
    });

    // Se llama directo, sin requestAnimationFrame: son dos getBoundingClientRect
    // por evento (baratísimo) y, sobre todo, rAF se CONGELA cuando la pestaña
    // está en segundo plano, así que la barra se quedaba como estuviera.
    window.addEventListener('scroll', revisa, { passive: true });
    window.addEventListener('resize', revisa);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) revisa();
    });
    revisa();
  }

  /* --- Barra fija de la portada -------------------------------------------
     Misma idea que la de la ficha, pero aquí no hay formulario: el botón es un
     enlace al producto. Se esconde cuando entra en pantalla el cierre (que ya
     lleva su propio botón) o el pie, para no tener dos botones a la vez.     */
  function initBarraHero() {
    var barra = document.querySelector('[data-cd-barra-hero]');
    if (!barra) return;
    /* Marcada la barra antes de atarla. En el editor esta función se vuelve a
       lanzar en cada recarga de sección y dejaba otro par de escuchadores de
       scroll sobre la MISMA barra. 9 sept 2026.                            */
    if (barra.__cdAtada) return;
    barra.__cdAtada = true;
    var boton = document.querySelector('[data-cd-hero-cta]');
    var enlace = barra.querySelector('.cd-barra__btn');
    if (!boton || !enlace) return;

    // El botón del cierre, no la sección: la sección mide 630 px y empieza
    // mucho antes que su botón, así que la barra desaparecía demasiado pronto.
    var cierre = document.querySelector('.cd-cta .cd-btn') || document.querySelector('.cd-cta');
    var pie = document.querySelector('.cd-ft') || document.querySelector('footer');
    var visible = false;

    function pinta(mostrar) {
      if (mostrar === visible) return;
      visible = mostrar;
      barra.classList.toggle('cd-barra--fuera', mostrar);
      barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
      enlace.tabIndex = mostrar ? 0 : -1;
    }

    function asoma(el, margen) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.top < window.innerHeight - margen && r.bottom > 0;
    }

    function revisa() {
      var pasado = boton.getBoundingClientRect().bottom < 0;
      pinta(pasado && !asoma(cierre, 60) && !asoma(pie, 40));
    }

    // Sin requestAnimationFrame a propósito: se congela con la pestaña oculta.
    window.addEventListener('scroll', revisa, { passive: true });
    window.addEventListener('resize', revisa);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) revisa();
    });
    revisa();
  }

  /* --- Cupón: copiar al portapapeles --------------------------------------- */
  function initCupon() {
    document.querySelectorAll('[data-cd-copiar]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var codigo = btn.getAttribute('data-cd-codigo') || '';
        var etiqueta = btn.querySelector('[data-cd-copiar-texto]');
        function hecho() {
          btn.classList.add('cd-copiado');
          if (etiqueta) etiqueta.textContent = '¡Copiado!';
          setTimeout(function () {
            btn.classList.remove('cd-copiado');
            if (etiqueta) etiqueta.textContent = codigo;
          }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(hecho, hecho);
        } else {
          var ta = document.createElement('textarea');
          ta.value = codigo;
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
          hecho();
        }
      });
    });
  }

  /* --- Carrusel de reseñas: flechas + arrastre ----------------------------- */
  function initResenas() {
    document.querySelectorAll('[data-cd-res]').forEach(function (zona) {
      var carril = zona.querySelector('[data-cd-res-carril]');
      var ant = zona.querySelector('[data-cd-res-ant]');
      var sig = zona.querySelector('[data-cd-res-sig]');
      if (!carril) return;

      function paso() {
        var t = carril.querySelector('.cd-res__tarjeta');
        return t ? (t.getBoundingClientRect().width + 18) * 2 : carril.clientWidth * 0.8;
      }
      function actualiza() {
        if (ant) ant.disabled = carril.scrollLeft <= 4;
        if (sig) sig.disabled = carril.scrollLeft >= carril.scrollWidth - carril.clientWidth - 4;
      }
      if (ant) ant.addEventListener('click', function () { carril.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      if (sig) sig.addEventListener('click', function () { carril.scrollBy({ left: paso(), behavior: 'smooth' }); });
      carril.addEventListener('scroll', actualiza, { passive: true });
      actualiza();

      // arrastre con el ratón en escritorio
      var x0 = null, s0 = 0;
      carril.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        x0 = e.clientX; s0 = carril.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (x0 === null) return;
        carril.scrollLeft = s0 - (e.clientX - x0);
      });
      window.addEventListener('pointerup', function () { x0 = null; });
    });
  }

  /* --- Arranque ----------------------------------------------------------- */

  /* --- CESTA: añadir sin recargar, aviso y recomendaciones ----------------
     Hasta ahora el botón de la ficha era un formulario normal: recargaba la
     página entera y te dejaba en el carrito, sin forma de seguir comprando.
     Aquí se intercepta ese envío y se hace por /cart/add.js.

     REGLA DE ORO: si cualquier cosa falla —red, respuesta rara, navegador
     viejo— se deja que el formulario se envíe como toda la vida. Nunca se
     puede quedar un botón de comprar que no compra.                        */

  var CESTA_MONEDA = (window.Shopify && window.Shopify.currency &&
                      window.Shopify.currency.active) || 'EUR';

  function cestaDinero(centimos) {
    try {
      return new Intl.NumberFormat('es-ES', {
        style: 'currency', currency: CESTA_MONEDA
      }).format(centimos / 100);
    } catch (e) {
      return (centimos / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  /* La burbuja NUNCA puede quedarse visible y vacía: eso pinta un punto rojo
     sin número, que no significa nada. Si llega un valor raro —una respuesta a
     medias, un `undefined` de una promesa que se resolvió tarde— se trata como
     cero y se esconde, que es el estado honesto.                            */
  function cestaActualizaCuenta(total) {
    var b = document.querySelector('[data-cd-carrito]');
    if (!b) return;
    var n = Number(total);
    if (!isFinite(n) || n < 0) { n = 0; }
    b.textContent = String(n);
    if (n > 0) { b.removeAttribute('hidden'); } else { b.setAttribute('hidden', ''); }
  }

  /* Relee la cesta y repinta todo lo que dependa de ella. La llama `arranca()`
     al cargar, cada cambio de la cesta, y `regaloAlVolver()` cuando la página
     vuelve de la caché de «atrás» —que la restaura tal cual estaba, con la
     cesta que hubiera entonces—.                                            */
  function cestaSincronizaCuenta() {
    if (!window.fetch || !document.querySelector('[data-cd-carrito]')) return;
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cestaTrasCambio(c); })
      .catch(function () {});
  }

  /* --- Bálsamo de regalo al llegar a 49 € ---------------------------------
     El regalo es un PRODUCTO APARTE a 0,00 € («Regalo · Bálsamo en barra
     medicube»), no un descuento. Lleva el mismo SKU que el bálsamo de pago
     (barra_medi) para que Dropea lo reconozca y lo envíe.

     Por qué producto y no descuento, que se probó todo el 8 sept 2026:
       · Un "compra X y llévate Y" ANULA los packs de cantidad. Con el regalo
         puesto así, tres bálsamos pasaban de 44,59 € a 63,62 €: al cliente le
         SUBÍA el total al aparecerle el regalo.
       · Un descuento de PEDIDO sí convivía con los packs, pero el 15 % caía
         también sobre el bote regalado y se escapaban 3,74 € por pedido.
       · Un producto a 0 € no toca nada: ni packs, ni 15 %, ni suma unidades al
         bálsamo de pago. Cuesta 3,69 € exactos y en el pago pone 0,00 €.

     El umbral se mide sobre `items_subtotal_price`, que es el valor después de
     los packs y antes del 15 %. El regalo vale 0 €, así que no se cuenta a sí
     mismo y no hay nada que restar.                                        */
  var REGALO_VARIANTE = 63459511140682;   // "Regalo · Bálsamo en barra medicube"
  /* El umbral NO se escribe aquí: se lee del <meta> que pone `theme.liquid`,
     que a su vez sale del ajuste del tema. Es el único sitio donde vive el
     número. Antes había una constante aquí y otra en el snippet de la barra, y
     cambiar solo una hacía que la barra dijera «te faltan X» con el umbral
     nuevo mientras el bote seguía entrando con el viejo. 9 sept 2026.
     El 4900 se queda de respaldo por si el <meta> no está. */
  var REGALO_UMBRAL = 4900;
  try {
    var metaUmbral = document.querySelector('meta[name="cd-regalo-umbral"]');
    var leido = metaUmbral && Number(metaUmbral.getAttribute('content'));
    if (leido && isFinite(leido) && leido > 0) { REGALO_UMBRAL = leido; }
    /* 8 oct 2026 · Regalo apagado desde el ajuste del tema: ninguna cesta llega
       al umbral, así que el bote no entra y el que quede de antes se retira. */
    if (document.querySelector('meta[name="cd-regalo-apagado"]')) { REGALO_UMBRAL = Infinity; }
  } catch (e) {}
  var REGALO_ETIQUETA = 'Regalo';         // marca la línea; el carrito no la imprime

  /* Se busca por VARIANTE, no por la propiedad. Es importante: quien entre a
     /products/medicube-0-0 y le dé a añadir se mete el bote SIN la propiedad,
     y si solo miráramos la propiedad no lo reconoceríamos y se lo llevaría
     gratis sin comprar nada. Lo cazó Joni el 8 sept 2026.

     También se recogen las líneas que llevan la propiedad pero NO son la
     variante buena: son cestas viejas de cuando el regalo era el bálsamo de
     pago con un descuento de pedido.                                       */
  /* Lo que cuenta para los 49 € del regalo: SOLO las líneas de marca Claydale
     (lo que sale por Dropea). Las primeras marcas de BTSWholesaler (Shiseido,
     28 sept 2026) no cuentan: con un Shiseido solo, el bote de regalo viajaría
     solo en otro paquete de Dropea. Joni: «exclúyelos de los descuentos y el
     regalo». La suma de `final_line_price` de todas las líneas es justo
     `items_subtotal_price`, así que para lo de Claydale no cambia nada.
     La misma cuenta está en snippets/cd-regalo-barra.liquid.               */
  function regaloBase(carrito) {
    var total = 0;
    (carrito.items || []).forEach(function (i) {
      if (String(i.vendor || '').toLowerCase() === 'claydale') {
        total += (i.final_line_price != null ? i.final_line_price : i.line_price);
      }
    });
    return total;
  }

  /* Marcas de la cesta que NO suman para el regalo, para decirlo en la barra. */
  function regaloFuera(carrito) {
    var marcas = [];
    (carrito.items || []).forEach(function (i) {
      var m = String(i.vendor || '');
      if (m && m.toLowerCase() !== 'claydale' && marcas.indexOf(m) === -1) { marcas.push(m); }
    });
    return marcas;
  }

  function regaloLineas(carrito) {
    var lista = [];
    (carrito.items || []).forEach(function (i) {
      if (Number(i.variant_id) === REGALO_VARIANTE ||
          (i.properties && i.properties[REGALO_ETIQUETA])) { lista.push(i); }
    });
    return lista;
  }

  /* En la página de la cesta hay que redibujar la lista. `onCartUpdate` es lo
     que usa Dawn para repintar `main-cart-items` sin recargar.              */
  function regaloRepinta() {
    var ci = document.querySelector('cart-items');
    if (ci && typeof ci.onCartUpdate === 'function') { ci.onCartUpdate(); }
  }

  /* La barra de «te faltan X € para tu bálsamo gratis». La pinta primero
     Liquid en el servidor (snippets/cd-regalo-barra.liquid), así que es
     correcta sin JS; esto solo la rehace cuando cambia la cesta sin recargar.
     Cuenta lo MISMO que regaloSincroniza: items_subtotal_price.               */
  function regaloPintaBarra(carrito) {
    var valor = regaloBase(carrito);
    document.querySelectorAll('[data-cd-regalo-barra]').forEach(function (caja) {
      var umbral = Number(caja.getAttribute('data-umbral')) || REGALO_UMBRAL;
      if (!umbral) return;
      if (valor <= 0 && !caja.hasAttribute('data-siempre')) { caja.hidden = true; return; }
      caja.hidden = false;

      var falta = umbral - valor;
      var txt = caja.querySelector('[data-cd-regalo-texto]');
      var tot = caja.querySelector('[data-cd-regalo-total]');
      var rel = caja.querySelector('[data-cd-regalo-relleno]');

      var fuera = caja.querySelector('[data-cd-regalo-fuera]');
      if (fuera) {
        var marcasFuera = regaloFuera(carrito);
        var hueco = fuera.querySelector('[data-cd-regalo-fuera-marcas]');
        if (hueco) hueco.textContent = marcasFuera.join(' y ');
        fuera.hidden = !marcasFuera.length;
      }
      var notaTotal = caja.querySelector('[data-cd-regalo-calculo]');
      if (notaTotal) notaTotal.hidden = valor <= 0;
      if (tot) {
        tot.textContent = cestaDinero(carrito.total_price != null ? carrito.total_price : valor);
        /* Se esconde el RENGLÓN entero, no el número: escondiendo solo el
           <strong> quedaba un «En la cesta:» suelto sin cifra detrás.       */
        var linea = tot.parentNode;
        if (linea && linea.nodeType === 1) { linea.hidden = valor <= 0; }
      }
      if (txt) {
        if (regaloRechazado(carrito) && valor >= umbral) {
          txt.innerHTML = 'Tienes un bálsamo de medicube de regalo esperando' +
            ' <button type="button" class="cd-envio__add" data-cd-regalo-add>Añadirlo</button>';
        } else if (valor <= 0) {
          txt.innerHTML = 'Desde <strong>' + cestaDinero(umbral) +
                          '</strong> te llevas un bálsamo de medicube de regalo';
        } else if (falta > 0) {
          txt.innerHTML = 'Te faltan <strong>' + cestaDinero(falta) +
                          '</strong> para tener tu bálsamo de medicube gratis';
        } else if (regaloLineas(carrito).length) {
          txt.innerHTML = '¡Ya tienes tu bálsamo de medicube gratis!';
        } else {
          /* Ha cruzado los 49 € pero el bote AÚN NO está en la cesta: entre una
             cosa y otra pasan 1-3 segundos. Decir «ya lo tienes» ahí es mentira,
             y la ve TODO el mundo, no solo quien lo rechazó. «Conseguido» es
             cierto desde el instante en que cruza. 9 sept 2026.             */
          txt.innerHTML = 'Conseguido: tu bálsamo de medicube de regalo';
        }
      }
      var eleccion = caja.querySelector('[data-cd-regalo-eleccion]');
      var quitar = caja.querySelector('[data-cd-regalo-quitar]');
      var sin = caja.querySelector('[data-cd-regalo-sin]');
      if (eleccion) eleccion.hidden = valor < umbral;
      if (quitar) quitar.hidden = regaloRechazado(carrito);
      if (sin) sin.hidden = !regaloRechazado(carrito);
      document.querySelectorAll('[data-cd-pago-texto]').forEach(function (pago) {
        pago.textContent = regaloLineas(carrito).length && !regaloRechazado(carrito)
          ? caja.getAttribute('data-pago-online') : pago.getAttribute('data-normal');
      });
      if (rel) {
        var pct = Math.min(100, Math.round(valor * 100 / umbral));
        rel.style.width = pct + '%';
        if (falta > 0) { rel.classList.remove('is-lleno'); }
        else { rel.classList.add('is-lleno'); }
      }
    });
  }

  /* --- El corazón del regalo -----------------------------------------------
     Deja la cesta como tiene que estar, y NO se fía de nadie: relee /cart.js en
     cada vuelta y repite hasta que cuadra (tope de 4 vueltas).

     La versión anterior arreglaba UNA cosa por pasada y confiaba en que el
     repintado la volviera a llamar, con un booleano `ocupado` de cerrojo. Se
     quedaba colgada: bajando de 49 € con el «−» del carrito el bote NO se
     retiraba, la barra sí bajaba, y el pedido se podía pagar con el regalo
     dentro. Lo cazó Joni el 8 sept 2026.

     Ahora las llamadas van en una COLA de promesas (no un booleano, que se
     pierde si dos cosas pasan a la vez) y se itera hasta dejarlo bien, sin
     depender de que nadie repinte nada.                                    */
  /* REINTENTA, y no es un lujo: Shopify devuelve 422 cuando le llegan dos
     escrituras a la vez sobre la misma cesta, y eso pasa constantemente — al
     pulsar el «+» del carrito, Dawn está escribiendo su cambio de cantidad
     justo cuando nosotros metemos el bote. Sin reintento, ese 422 se tragaba
     en silencio y el regalo no llegaba nunca.                              */
  function regaloPeticion(url, cuerpo, intento) {
    intento = intento || 1;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json',
                 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) {
      if (r.ok) return r.json();
      /* SOLO se reintenta lo que puede curarse solo: el 422 de dos escrituras
         a la vez, el 429 de exceso de peticiones y los 5xx del servidor. Un
         404 o un 403 significan que ese producto ya no se puede añadir —
         despublicado o borrado— y reintentarlo es alimentar un bucle que
         seguiría hasta que el cliente cerrara la pestaña.                  */
      var recuperable = (r.status === 422 || r.status === 429 || r.status >= 500);
      if (recuperable && intento < 5) {
        return new Promise(function (ok) { window.setTimeout(ok, 300 * intento); })
          .then(function () { return regaloPeticion(url, cuerpo, intento + 1); });
      }
      throw new Error('regalo ' + r.status);
    });
  }

  var regaloFallos    = 0;       // ciclos seguidos que han acabado mal
  var regaloRoto      = false;   // automatismo apagado tras fallar de seguido
  var regaloEnMarcha  = false;   // hay una revisión corriendo
  var regaloPendiente = false;   // ha cambiado algo mientras corría
  var regaloEsperas   = [];      // quien pidió una revisión mientras había otra

  /* Avisa a todo el que se quedó esperando a que la cesta estuviera quieta.
     Se llama SOLO cuando no queda trabajo apuntado: si aún hay una pasada
     pendiente, los que esperan se avisan al terminar ESA, no antes.        */
  function regaloAvisaEsperas() {
    if (!regaloEsperas.length) return;
    var lista = regaloEsperas;
    regaloEsperas = [];
    lista.forEach(function (avisa) {
      try { avisa(); } catch (e) {}
    });
  }

  /* Los botones de pago acelerado (Shop Pay, PayPal) NO se pueden interceptar:
     Shop Pay va dentro de un componente con shadow DOM —el clic llega al
     documento con el target cambiado, y no se puede volver a lanzar dentro— y
     PayPal va dentro de un iframe, así que el clic ni siquiera llega a esta
     página. Por eso al guardián del «Pagar pedido» se le escapaban enteros y
     se podía pagar con la cesta a medio arreglar.

     La salida no es interceptarlos: es APAGARLOS, y solo mientras el motor
     está escribiendo en la cesta, que es la única ventana en la que la cesta
     está mal. Con la cesta ya correcta no se tocan nunca — al cargar la
     página, por ejemplo, no se bloquean.                                   */
  var REGALO_ACELERADOS = '.additional-checkout-buttons, #dynamic-checkout-cart, [data-shopify="dynamic-checkout-cart"]';
  var regaloRelojAcelerados = null;

  function regaloAcelerados(bloquea) {
    var nodos;
    try { nodos = document.querySelectorAll(REGALO_ACELERADOS); }
    catch (e) { return; }
    Array.prototype.forEach.call(nodos, function (n) {
      if (bloquea) {
        n.setAttribute('data-cd-regalo-espera', '1');
        n.setAttribute('aria-busy', 'true');
      } else {
        n.removeAttribute('data-cd-regalo-espera');
        n.removeAttribute('aria-busy');
      }
    });
    if (regaloRelojAcelerados) { window.clearTimeout(regaloRelojAcelerados); regaloRelojAcelerados = null; }
    /* Vigía: pase lo que pase, estos botones NUNCA se quedan apagados. */
    if (bloquea) {
      regaloRelojAcelerados = window.setTimeout(function () { regaloAcelerados(false); }, 5000);
    }
  }

  function regaloRechazado(carrito) {
    return !!(carrito && carrito.attributes && carrito.attributes['_sin_regalo']);
  }

  /* Si algo falla, SE DICE. Estos dos botones anulan la vía normal de Dawn
     (preventDefault + stopPropagation), así que si la petición se cae y nos
     callamos, el cliente pulsa la papelera y no pasa absolutamente nada: ni se
     quita el bote, ni sale un aviso, ni funciona la papelera de siempre. Y como
     llevar el bote le quita el contrarrembolso, se queda sin poder pagar como
     quiere. En el carrito hay un hueco para esto (`#cart-errors`); donde no lo
     haya, al menos queda en la consola. 9 sept 2026.                        */
  function regaloAvisaFallo(texto, e) {
    if (window.console && console.warn) { console.warn('[cd] regalo: ' + texto, e || ''); }
    try {
      document.querySelectorAll('[data-cd-regalo-error]').forEach(function (el) {
        el.hidden = false;
        el.textContent = texto;
      });
      var hueco = document.getElementById('cart-errors');
      if (hueco) {
        hueco.textContent = texto;
        hueco.setAttribute('role', 'alert');
      }
    } catch (err) {}
  }

  /* Le da a la papelera del regalo: se apunta que NO lo quiere y se quita. La
     marca va en un atributo del carrito que empieza por guión bajo, así que
     Shopify no se la enseña a nadie.                                        */
  function regaloRechaza() {
    /* Las DOS peticiones con reintento. Antes la primera —la que escribe el
       atributo— era un `fetch` pelado sin ninguno, mientras la segunda sí los
       tenía: el eslabón frágil era justo el que nadie miraba.               */
    return regaloPeticion('/cart/update.js', { attributes: { '_sin_regalo': '1' } })
      .then(function (c) {
        var l = regaloLineas(c)[0];
        if (!l) return null;
        return regaloPeticion('/cart/change.js', { id: l.key, quantity: 0 });
      })
      .then(function () { regaloRepinta(); cestaSincronizaCuenta(); })
      .catch(function (e) {
        regaloAvisaFallo('No hemos podido quitar el regalo. Inténtalo otra vez en unos segundos.', e);
      });
  }

  /* Y si se arrepiente, desde la propia barra. */
  function regaloAcepta() {
    return regaloPeticion('/cart/update.js', { attributes: { '_sin_regalo': '' } })
      .then(function () { return regaloSincroniza(); })
      .catch(function (e) {
        regaloAvisaFallo('No hemos podido añadir el regalo. Inténtalo otra vez en unos segundos.', e);
      });
  }

  function initRegaloBotones() {
    if (document.__cdRegaloBotones) return;
    document.__cdRegaloBotones = true;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-cd-regalo-quitar]')) {
        e.preventDefault(); e.stopPropagation();
        var quitar = t.closest('[data-cd-regalo-quitar]');
        if (quitar.disabled) return;
        if (regaloPagoPendiente) regaloPagoPendiente();
        quitar.disabled = true;
        quitar.setAttribute('aria-busy', 'true');
        regaloRechaza().finally(function () {
          quitar.disabled = false;
          quitar.removeAttribute('aria-busy');
        });
        return;
      }
      if (t.closest('.cd-item-regalo cart-remove-button')) {
        e.preventDefault(); e.stopPropagation();
        regaloRechaza();
        return;
      }
      if (t.closest('[data-cd-regalo-add]')) {
        e.preventDefault(); e.stopPropagation();
        regaloAcepta();
      }
    }, true);
  }

  function regaloSincroniza() {
    window.__cdRegalo = { enMarcha: regaloEnMarcha, pendiente: regaloPendiente,
                          entradas: (window.__cdRegalo && window.__cdRegalo.entradas || 0) + 1,
                          ultima: 'entrada' };
    if (!window.fetch) return Promise.resolve();
    // Si el automatismo se ha apagado, no se vuelve a intentar en esta visita.
    if (regaloRoto) return Promise.resolve();
    /* Si ya hay una en marcha, se apunta y se hace al terminar. Nunca se pierde.
       Y se devuelve una promesa QUE DE VERDAD ESPERA: antes se devolvía una ya
       resuelta, así que el guardián del botón de pagar creía que el trabajo
       estaba hecho y soltaba el clic en el mismo instante. Justo en la ventana
       de 2-3 s en la que se cruza el umbral de los 49 €, que es la única que
       importa. Se pagaba sin el regalo al subir, y con el regalo puesto al
       bajar. Lo cazó la auditoría del 9 sept 2026.                          */
    if (regaloEnMarcha) {
      regaloPendiente = true;
      if (!window.Promise) return { then: function (f) { f(); return this; }, catch: function () { return this; } };
      return new Promise(function (avisa) {
        regaloEsperas.push(avisa);
        /* Red de seguridad: NINGUNA espera puede quedarse colgada. Si en 2,5 s
           no la ha avisado nadie, se descuelga sola. Va por debajo del tope de
           3 s del guardián a propósito: así el clic sale por su propia promesa
           y no por el temporizador bruto.                                    */
        window.setTimeout(function () {
          var i = regaloEsperas.indexOf(avisa);
          if (i < 0) return;
          regaloEsperas.splice(i, 1);
          avisa();
        }, 2500);
      });
    }
    regaloEnMarcha = true;
    window.__cdRegalo.ultima = 'arranca';

    var cambiado = false;

    /* `cambiado` se marca DESPUÉS, y solo si la escritura ha salido bien. Si se
       marcaba antes, una escritura que falla hacía creer a `termina` que había
       cambiado algo, y programaba otra revisión a los 1200 ms... que volvía a
       fallar. Bucle infinito de peticiones mientras el cliente tuviera la
       página abierta. Hoy no salta porque la variante está en «seguir
       vendiendo», pero saltaría el día que se apague la promo despublicando el
       producto, que es lo natural.                                         */
    function escribe(url, cuerpo) {
      // A partir de aquí la cesta está a medias: fuera los botones acelerados.
      regaloAcelerados(true);
      return regaloPeticion(url, cuerpo).then(function (r) {
        cambiado = true;
        return r;
      });
    }
    function quita(key)        { return escribe('/cart/change.js', { id: key, quantity: 0 }); }
    function deja1(key)        { return escribe('/cart/change.js', { id: key, quantity: 1 }); }
    function pon() {
      var props = {}; props[REGALO_ETIQUETA] = '1';
      return escribe('/cart/add.js',
        { items: [{ id: REGALO_VARIANTE, quantity: 1, properties: props }] });
    }

    function pasada(n) {
      if (n > 4) return Promise.resolve();
      return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          regaloPintaBarra(c);
          var lineas = regaloLineas(c);
          window.__cdRegalo.ultima = 'pasada n=' + n + ' lineas=' + lineas.length + ' sub=' + regaloBase(c);
          var leToca = regaloBase(c) >= REGALO_UMBRAL;
          var sig = function () { return pasada(n + 1); };

          // No llega a 49 €: fuera el bote, venga de donde venga.
          if (!leToca) {
            if (lineas.length) { return quita(lineas[0].key).then(sig); }
            /* Y se borra la negativa. El «no quiero el regalo» se guarda como
               atributo del carrito, y los atributos de Shopify sobreviven a que
               la cesta se quede vacía: viven con la cookie, semanas. Sin esto,
               quien lo rechazó una vez para poder pagar contrarrembolso seguía
               teniendo que pedirlo a mano en el pedido siguiente.
               Por debajo del umbral no hay regalo que rechazar, así que la
               negativa deja de tener sentido: se limpia y la próxima vez que
               suba de 49 € se le vuelve a ofrecer solo. 9 sept 2026.        */
            if (regaloRechazado(c)) {
              return escribe('/cart/update.js', { attributes: { '_sin_regalo': '' } }).then(sig);
            }
            return null;
          }
          /* Le toca, pero él dijo que no: fuera el bote. Hace falta porque
             `regaloRechaza` hace DOS cosas —apuntar la negativa y quitar la
             línea— y si la segunda se cae, la cesta se quedaba con la negativa
             escrita y el bote dentro: nadie lo retiraba nunca y seguía sin
             poder pagar contrarrembolso. Ahora lo remata la siguiente pasada,
             que se dispara sola en cada cambio de la cesta. 9 sept 2026.   */
          if (regaloRechazado(c) && lineas.length) { return quita(lineas[0].key).then(sig); }
          // Le toca pero lo tiene repetido: se queda con uno.
          if (lineas.length > 1) { return quita(lineas[lineas.length - 1].key).then(sig); }
          if (lineas.length === 1) {
            var l = lineas[0];
            // Cesta vieja: la línea marcada no es la variante del regalo.
            if (Number(l.variant_id) !== REGALO_VARIANTE) { return quita(l.key).then(sig); }
            // Le han subido la cantidad a mano.
            if (l.quantity > 1) { return deja1(l.key).then(sig); }
            return null;
          }
          // Le toca y no lo tiene. Pero si lo ha quitado a mano, NO se le
          // vuelve a colar: llevarlo le deja sin pago contra reembolso, así que
          // renunciar tiene que ser una decisión que se respete.
          if (regaloRechazado(c)) return null;
          return pon().then(sig);
        });
    }

    /* `termina` se llama TANTO si sale bien como si falla. Esa es la gracia:
       el cerrojo se suelta siempre. La versión anterior encadenaba promesas y,
       si una se quedaba sin resolver, todo lo de detrás se quedaba esperando
       para siempre: la barra decía «¡ya lo tienes!» y el bote no llegaba, o al
       bajar de 49 € no se retiraba y se podía pagar con el regalo dentro.
       Lo cazó Joni el 8 sept 2026.                                         */
    function termina(fallo) {
      if (fallo) {
        regaloFallos = regaloFallos + 1;
        if (regaloFallos >= 3) {
          regaloRoto = true;
          /* Tres ciclos seguidos fallando: se apaga. Y se esconde la barra,
             porque prometer un regalo que no va a llegar es peor que no
             prometer nada.                                                 */
          try {
            document.querySelectorAll('[data-cd-regalo-barra]').forEach(function (caja) { caja.hidden = true; });
          } catch (e) {}
          if (window.console && console.warn) {
            console.warn('[cd] regalo: tres ciclos seguidos fallando, se apaga el automatismo');
          }
        }
      } else {
        regaloFallos = 0;
      }
      /* Todo lo que puede petar va envuelto, y la bandera se lee y se limpia
         ANTES de tocar nada: `regaloRepinta()` llama a `onCartUpdate()` de
         Dawn, que es código ajeno y que ya se sabe que revienta (por eso
         existe el parche de `getSectionsToRender` de más abajo). Si esa
         excepción subiera, se saltaría el aviso a los que esperan y el botón
         de pagar se quedaría muerto tres segundos en cada clic.             */
      try { window.__cdRegalo.ultima = 'termina cambiado=' + cambiado; } catch (e) {}
      regaloEnMarcha = false;
      /* Se sueltan SIEMPRE y lo primero, antes de nada que pueda petar. Si la
         pasada siguiente vuelve a escribir, `escribe` los apaga otra vez.   */
      try { regaloAcelerados(false); } catch (e) {}
      var repite = regaloPendiente;
      regaloPendiente = false;
      try {
        if (cambiado) { regaloRepinta(); cestaSincronizaCuenta(); }
      } catch (e) {
        if (window.console && console.error) { console.error('[cd] regalo: falló el repintado', e); }
      }
      if (repite) {
        // Queda trabajo: NO se avisa todavía a los que esperan. Se les avisa
        // cuando termine la pasada que va a recoger ese trabajo.
        window.setTimeout(regaloSincroniza, 250);
      } else {
        regaloAvisaEsperas();
        if (cambiado) {
          // Un repaso por si Dawn escribió encima mientras tanto. Si ya está
          // bien, esta pasada no cambia nada y no encadena otra.
          window.setTimeout(regaloSincroniza, 1200);
        }
      }
    }

    /* Si `pasada(1)` lanzara de forma SÍNCRONA —una app o una extensión que
       envuelve `window.fetch` y se rompe—, el `.then` no llegaría a engancharse
       y `regaloEnMarcha` se quedaría en true para siempre: a partir de ahí cada
       clic en pagar esperaría los 3 s enteros. Con esto el cerrojo se suelta
       igual.                                                                 */
    var marcha;
    try { marcha = pasada(1); }
    catch (e) { marcha = Promise.reject(e); }
    return marcha.then(function () { termina(false); }, function () { termina(true); });
  }

  /* --- Que nadie se vaya al pago sin su regalo -----------------------------
     El bote se mete con una llamada al carrito, y entre que el cliente pasa de
     49 € y esa llamada termina pasan 2-3 SEGUNDOS (medido). En la página de la
     cesta el botón de pagar está justo al lado del «+», así que dando a los dos
     seguidos te ibas al pago sin el regalo. Lo cazó Joni el 8 sept 2026.

     Aquí se para el clic, se relee la cesta DE VERDAD y solo entonces se deja
     pasar. Si tarda más de 2,5 s se deja pasar igual: antes perder el regalo
     que dejar a alguien atascado en el botón de pagar.                     */
  var REGALO_PAGO = 'a[href*="/checkout"], button[name="checkout"], [data-cd-cesta-pagar], #checkout';

  /* Cuando se deja pasar el clic hay que evitar entrar aquí otra vez, porque
     `boton.click()` vuelve a despachar el evento por este mismo escuchador y se
     monta un bucle sin fin (medido: no para solo; el banco lo cortó a las 26).

     Antes esto se marcaba EN EL NODO (`boton.__cdRegaloListo = true`) y no se
     quitaba nunca. El «Pagar» del aviso de «añadido a tu cesta» es un enlace
     suelto dentro de <body> que no se repinta jamás, así que al volver con
     «atrás» el navegador restauraba ESE MISMO nodo con la marca puesta y el
     guardián no lo miraba nunca más. Y nada lo impide: la tienda no manda
     ningún `Cache-Control` al navegador (el `cdn-cache-control` que sí manda es
     para la CDN, el navegador lo ignora) y el tema no registra `unload`, que
     son las dos cosas que apagarían esa caché.

     Esta bandera vive un instante: se pone justo antes del `click()` y se quita
     justo después, y el despacho del evento es SÍNCRONO, así que para cuando el
     navegador se lleva la página ya está a false. En la rama del <a> ni
     siquiera hace falta: asignar `location.href` no despacha ningún clic — allí
     la marca vieja no servía para nada, y era justo donde se quedaba pegada.
     9 sept 2026.                                                            */
  var regaloSoltando = false;

  /* Un clic de pago retenido y sin soltar todavía; sirve para anularlo al
     volver de la caché de «atrás». Solo puede haber uno a la vez.          */
  var regaloPagoPendiente = null;

  function regaloAntesDePagar(e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey) return;
    if (regaloSoltando) return;
    var boton = e.target && e.target.closest ? e.target.closest(REGALO_PAGO) : null;
    if (!boton || !window.fetch) return;

    /* Ya hay un clic de este botón esperando. Antes esto era un `return` pelado,
       y un `return` NO cancela el clic: el navegador seguía su curso y se
       llevaba al cliente al pago sin esperar al regalo. O sea que el impaciente
       que pulsa dos veces se quedaba justo sin lo que este guardián existe para
       darle. Medido: tres pulsaciones separadas 200 ms = tres navegaciones.
       Ahora el segundo clic no hace nada y manda el primero, que suelta como
       mucho a los 3 s. 9 sept 2026.                                         */
    if (boton.__cdRegaloEsperando) { e.preventDefault(); e.stopPropagation(); return; }

    e.preventDefault();
    e.stopPropagation();

    /* Mientras se espera, el botón no da ninguna señal. Sin esta bandera el
       cliente impaciente vuelve a pulsar, entra otra vez aquí y acaban
       llamando dos veces a `boton.click()`: doble envío al pago.            */
    boton.__cdRegaloEsperando = true;
    boton.setAttribute('aria-busy', 'true');

    var soltado = false;
    function suelta() {
      if (soltado) return;
      soltado = true;
      regaloPagoPendiente = null;
      boton.__cdRegaloEsperando = false;
      boton.removeAttribute('aria-busy');
      if (boton.tagName === 'A' && boton.href) { window.location.href = boton.href; }
      else {
        regaloSoltando = true;
        try { boton.click(); } finally { regaloSoltando = false; }
      }
    }
    var reloj = window.setTimeout(suelta, 3000);

    /* Y una manera de ANULARLO. Si el cliente pulsa «Pagar» y antes de los 3 s
       se va por otro lado —«Ver la cesta» está en el <div> de al lado—, la
       página se congela con este temporizador a medias. Al volver con «atrás»
       el navegador lo reanuda, `suelta()` corre y hace
       `window.location.href = '/checkout'`: la tienda se lleva sola al cliente
       al pago, justo cuando él acababa de pedir lo contrario. 9 sept 2026.   */
    regaloPagoPendiente = function () {
      soltado = true;
      window.clearTimeout(reloj);
      boton.__cdRegaloEsperando = false;
      boton.removeAttribute('aria-busy');
      regaloPagoPendiente = null;
    };

    regaloSincroniza()
      .then(function () { window.clearTimeout(reloj); suelta(); })
      .catch(function () { window.clearTimeout(reloj); suelta(); });
  }

  /* --- Volver con «atrás» ---------------------------------------------------
     La caché de «atrás» del navegador no restaura solo el HTML: devuelve la
     página CONGELADA entera, con el montón de JavaScript intacto. O sea que
     vuelve todo lo que estuviera a medias cuando el cliente se fue. Y aquí
     había tres cosas que se quedaban pegadas:

     1. `__cdRegaloEsperando` en el botón. Sí hace falta mientras se relee la
        cesta —el botón no da ninguna señal, y sin ella el impaciente pulsa otra
        vez y se envía dos veces al pago—, pero se quita en `suelta()`, y
        `suelta()` no corre si el cliente se va mientras espera. Al volver, ese
        botón queda sin vigilar para siempre, y encima con un `aria-busy="true"`
        fijo que un lector de pantalla lee como «ocupado».
     2. El cerrojo `regaloEnMarcha`. Si la página se congeló con una revisión
        corriendo, las peticiones se quedaron en el aire y nadie llamó a
        `termina()`. Al volver, el cerrojo sigue echado: cada `regaloSincroniza`
        se limita a apuntarse en la cola y soltarse sola a los 2,5 s sin hacer
        nada. El regalo deja de funcionar el resto de la visita.
     3. `regaloSoltando`, por el mismo motivo.

     Se limpian las tres. Y SOLO cuando la página vuelve de verdad de esa caché
     (`e.persisted`): en una carga normal no hay nada que limpiar, y tocar el
     cerrojo ahí pisaría el ciclo que `arranca()` acaba de poner en marcha.

     Ese `e.persisted` arregla además un desperdicio: `pageshow` se dispara
     TAMBIÉN en cada carga normal, y como `arranca()` ya llama a
     `cestaSincronizaCuenta` en su lista, la cesta se leía dos veces en cada
     página que se abría. Medido: 4 peticiones a /cart.js donde bastan 2, a
     200-330 ms cada una. 9 sept 2026.                                       */
  function regaloAlVolver(e) {
    if (!e || !e.persisted) return;

    /* Lo primero: anular un clic de pago que se quedara a medias, antes de que
       su temporizador reanudado se lleve al cliente al pago sin querer.     */
    if (regaloPagoPendiente) { try { regaloPagoPendiente(); } catch (err) {} }

    regaloSoltando = false;
    try {
      var botones = document.querySelectorAll(REGALO_PAGO);
      for (var i = 0; i < botones.length; i++) {
        botones[i].__cdRegaloEsperando = false;
        botones[i].removeAttribute('aria-busy');
      }
    } catch (err) {}

    /* El cerrojo se suelta y se avisa a quien se hubiera quedado esperando
       detrás, que si no se queda colgado hasta su propio tope de 2,5 s.     */
    regaloEnMarcha = false;
    regaloPendiente = false;
    regaloAvisaEsperas();

    cestaSincronizaCuenta();
  }

  /* Todo lo que hay que hacer cuando cambia la cesta, en UN solo sitio, para
     que no quede ningún camino sin revisar el regalo.                       */
  function cestaTrasCambio(c) {
    cestaActualizaCuenta(c.item_count);
    cestaPintaEnvio(c);
    regaloPintaBarra(c);
    regaloSincroniza();
    return c;
  }

  /* Pide una tanda de recomendaciones y devuelve las tarjetas ya en HTML.
     Se usa la API de secciones de Shopify en vez de dibujar las tarjetas a
     mano en JS: así el precio y el nombre los sigue poniendo Liquid desde el
     catálogo, que es la única forma de que no se descuadren del carrito.   */
  function cestaPideRecos(url) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return [];
        var d = document.createElement('div');
        d.innerHTML = html;
        return Array.prototype.slice.call(d.querySelectorAll('[data-cd-reco]'));
      })
      .catch(function () { return []; });
  }

  /* Cascada de tres, y siempre quitando lo que ya está en la cesta:
       1. los complementarios que elige Joni en Búsqueda y Descubrimiento
       2. los automáticos de Shopify
       3. la colección de respaldo del ajuste de la sección
     Hace falta la 3 porque el motor de Shopify recomienda por "se compran
     juntos" y por tipo de producto, y aquí cada producto está casi solo en su
     tipo: medido el 30 ago 2026, el estuche y las tiras devuelven CERO.     */
  function cestaRecomienda(idProducto, limite, soloOferta) {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (carrito) {
        var fuera = {};
        (carrito.items || []).forEach(function (i) { fuera[String(i.product_id)] = true; });
        var item = (carrito.items || []).find(function (i) { return String(i.product_id) === String(idProducto); });
        var form = document.querySelector('[data-cd-form]');
        var url = item && item.url;
        if (!url && form && form.getAttribute('data-cd-producto') === String(idProducto)) {
          url = form.getAttribute('data-cd-product-url');
        }
        if (!url) return [];
        return cestaPideRecos(url.split('?')[0] + '?section_id=cd-recos').then(function (tarjetas) {
          var validas = tarjetas.filter(function (t) {
            var id = String(t.getAttribute('data-producto-id'));
            return !fuera[id] && id !== String(idProducto);
          });
          /* 8 oct 2026 · Si el aviso va a anunciar «Llévate otro y los dos bajan un 15 %», solo
             salen productos que entran en esa oferta (solo en el aviso; la página de la cesta no cambia): fuera Shiseido, Payot y lo excluido (Joni:
             «añadí un aceite y me sugiere un Shiseido, y no están en la oferta»). */
          var conOferta = validas.filter(function (t) { return t.getAttribute('data-cd-reco-dto'); });
          if (soloOferta && conOferta.length) validas = conOferta;
          return validas.slice(0, limite);
        });
      })
      .catch(function () { return []; });
  }


  /* Ata las flechas y el arrastre de un carril de recomendaciones. Mismo
     comportamiento que el carrusel de reseñas: las flechas se apagan en los
     topes y en escritorio se puede arrastrar con el ratón. Se puede llamar
     varias veces sobre la misma zona (el aviso rellena sus tarjetas por JS),
     así que lleva marca para no duplicar escuchadores.                      */
  function cestaCarril(zona) {
    if (!zona) return;
    var pista = zona.querySelector('[data-cd-recos-pista]');
    var ant   = zona.querySelector('[data-cd-recos-ant]');
    var sig   = zona.querySelector('[data-cd-recos-sig]');
    if (!pista) return;

    function paso() {
      var t = pista.querySelector('[data-cd-reco]');
      return t ? (t.getBoundingClientRect().width + 12) * 2 : pista.clientWidth * 0.8;
    }
    function actualiza() {
      var sobra = pista.scrollWidth - pista.clientWidth > 4;
      if (ant) ant.disabled = !sobra || pista.scrollLeft <= 4;
      if (sig) sig.disabled = !sobra || pista.scrollLeft >= pista.scrollWidth - pista.clientWidth - 4;
    }
    zona.__cdActualiza = actualiza;

    if (!zona.__cdAtado) {
      zona.__cdAtado = true;
      if (ant) ant.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      if (sig) sig.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });
      pista.addEventListener('scroll', actualiza, { passive: true });
      window.addEventListener('resize', actualiza);

      var x0 = null, s0 = 0;
      pista.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        x0 = e.clientX; s0 = pista.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (x0 === null) return;
        pista.scrollLeft = s0 - (e.clientX - x0);
      });
      window.addEventListener('pointerup', function () { x0 = null; });
    }
    actualiza();
  }


  /* --- ARREGLO DEL CARRITO DE DAWN ---------------------------------------
     Fallo que YA ESTABA EN LA TIENDA EN VIVO, comprobado el 30 ago 2026 sobre
     `Claydale 16`: al cambiar la cantidad en la página del carrito, el total
     se quedaba congelado y salía "Hubo un error al actualizar tu carrito".
     La cesta sí se actualizaba en el servidor; lo que fallaba era la pantalla.

     Por qué: Dawn repinta CUATRO trozos y uno es `cart-icon-bubble`, que lo
     dibuja `header.liquid`. Claydale usa su propia cabecera `cd-header`, así
     que ese hueco no existe, `document.getElementById` devuelve null y revienta
     el bucle entero antes de llegar al total.

     Aquí se le dice que se salte los trozos que no tienen sitio donde ir, y la
     burbuja de la cabecera la actualizamos nosotros.                        */

  /* --- "Te faltan X para el envío gratis" ---------------------------------
     La cuenta la hace primero Liquid en el servidor, así que es correcta sin
     JS. Aquí solo se rehace cuando cambia la cesta sin recargar.

     Se descuentan los productos que ya viajan gratis (el estuche, que va por
     el perfil `AutoDS Free Shipping`): si la cesta solo lleva de esos, no hay
     nada que conseguir y el aviso se esconde.                               */
  function cestaPintaEnvio(carrito) {
    document.querySelectorAll('[data-cd-envio]').forEach(function (caja) {
      var umbral = Number(caja.getAttribute('data-umbral')) || 0;
      var libres = (caja.getAttribute('data-libres') || '').split(',').filter(Boolean);
      if (!umbral) return;

      var cuentan = 0;
      (carrito.items || []).forEach(function (i) {
        if (libres.indexOf(String(i.product_id)) === -1) {
          cuentan += (i.final_line_price != null ? i.final_line_price : i.line_price);
        }
      });

      if (cuentan <= 0) { caja.hidden = true; return; }
      caja.hidden = false;

      var falta = umbral - cuentan;
      var tot = caja.querySelector('[data-cd-envio-total]');
      if (tot) tot.textContent = cestaDinero(cuentan);
      var texto = caja.querySelector('[data-cd-envio-texto]');
      var relleno = caja.querySelector('[data-cd-envio-relleno]');

      if (texto) {
        texto.innerHTML = falta > 0
          ? (caja.getAttribute('data-falta') || 'Te faltan') + ' <strong>' +
            cestaDinero(falta) + '</strong> ' +
            (caja.getAttribute('data-falta2') || 'para el envío gratis')
          : (caja.getAttribute('data-hecho') || '¡Envío gratis conseguido!');
      }
      if (relleno) {
        var pct = Math.min(100, Math.round(cuentan * 100 / umbral));
        relleno.style.width = pct + '%';
        if (falta > 0) { relleno.classList.remove('is-lleno'); }
        else { relleno.classList.add('is-lleno'); }
      }
    });
  }

  function cestaRefrescaEnvio() {
    if (!document.querySelector('[data-cd-envio]')) return;
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(cestaPintaEnvio)
      .catch(function () {});
  }


  /* Aviso pequeño de "añadido", arriba a la derecha (abajo en móvil).
     Se va solo a los 4 segundos; el temporizador se reinicia si se añade otra
     cosa antes, para que no se apague a media frase.                        */
  var rapidoReloj = null;

  function cestaAvisaRapido(nombre) {
    var caja = document.querySelector('[data-cd-rapido]');
    if (!caja) return;
    var t = caja.querySelector('[data-cd-rapido-texto]');
    if (t) {
      t.innerHTML = nombre
        ? '<strong>' + nombre.replace(/</g, '&lt;') + '</strong> se ha añadido a tu cesta'
        : 'Se ha añadido a tu cesta';
    }
    caja.hidden = false;
    void caja.offsetHeight;
    caja.classList.add('is-visible');
    window.clearTimeout(rapidoReloj);
    rapidoReloj = window.setTimeout(cestaCierraRapido, 4000);
  }

  function cestaCierraRapido() {
    var caja = document.querySelector('[data-cd-rapido]');
    if (!caja) return;
    window.clearTimeout(rapidoReloj);
    caja.classList.remove('is-visible');
    window.setTimeout(function () { caja.hidden = true; }, menosMovimiento ? 0 : 460);
  }

  function initAvisoRapido() {
    var caja = document.querySelector('[data-cd-rapido]');
    if (!caja) return;
    caja.addEventListener('click', function (e) {
      if (e.target.closest('[data-cd-rapido-cerrar]')) { e.preventDefault(); cestaCierraRapido(); }
    });
    // si el ratón está encima, no se va: puede estar leyéndolo
    caja.addEventListener('mouseenter', function () { window.clearTimeout(rapidoReloj); });
    caja.addEventListener('mouseleave', function () { rapidoReloj = window.setTimeout(cestaCierraRapido, 1600); });
  }

  function initArregloCarritoDawn() {
    // OJO con el momento: este archivo va con `defer`, así que cuando arranca
    // la página ya está "interactiva" y el cart.js de Dawn AÚN NO ha corrido.
    // Buscando la clase aquí y ahora salía undefined y el parche no se ponía.
    // Se espera a que el elemento quede definido, que puede ser ya mismo.
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('cart-items').then(aplicaParcheCarrito).catch(function () {});
  }

  function aplicaParcheCarrito() {
    var C = customElements.get('cart-items');
    if (!C || !C.prototype.getSectionsToRender || C.prototype.__cdParcheado) return;
    C.prototype.__cdParcheado = true;

    /* ENGANCHE DIRECTO A DAWN. El vigilante de mutaciones de más abajo NO se
       entera cuando se cambia la cantidad con el «+/−» del carrito: Dawn
       repinta el trozo desde el servidor y el observador no salta. Resultado:
       al bajar de 49 € el bote NO se retiraba y se podía pagar con él dentro,
       y a veces al subir tampoco entraba. Lo cazó Joni el 8 sept 2026.
       Aquí se envuelven los dos métodos de Dawn que tocan la cesta para
       revisar el regalo justo después.                                     */
    /* LO PRIMERO QUE SE INTENTA: el evento que Dawn publica cuando YA ha leído
       la cesta nueva (`cart-update`, en cart.js justo después de parsear la
       respuesta). Es la señal buena: ni antes ni después.                   */
    var eventoDawn = false;
    try {
      if (typeof subscribe === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { regaloSincroniza(); });
        eventoDawn = true;
      }
    } catch (e) { eventoDawn = false; }

    /* Y el envoltorio de los dos métodos, como red.
       OJO CON `updateQuantity`: **NO devuelve nada**. Lanza su `fetch` sin
       `return`, así que la rama del `.then` no salta NUNCA por ahí (sí por
       `onCartUpdate`, que ese sí devuelve promesa). Hasta hoy lo único que
       quedaba era un `setTimeout` a ojo de 700 ms que, si Dawn tardaba más,
       leía la cesta VIEJA: una pasada inútil que además ponía
       `regaloEnMarcha = true` y dejaba sordo al guardián del botón de pagar.
       Por eso el temporizador ciego solo se pone si NO se ha podido enganchar
       el evento. Con el evento, sobra. 9 sept 2026.                        */
    ['updateQuantity', 'onCartUpdate'].forEach(function (metodo) {
      var previo = C.prototype[metodo];
      if (typeof previo !== 'function') return;
      C.prototype[metodo] = function () {
        var r = previo.apply(this, arguments);
        if (r && typeof r.then === 'function') {
          r.then(function () { regaloSincroniza(); }, function () { regaloSincroniza(); });
        }
        if (!eventoDawn) { window.setTimeout(regaloSincroniza, 700); }
        return r;
      };
    });

    var original = C.prototype.getSectionsToRender;
    C.prototype.getSectionsToRender = function () {
      return original.call(this).filter(function (t) {
        return document.getElementById(t.id);
      });
    };

    // La burbuja de la cabecera NO se ata a un método de Dawn: en esta versión
    // `renderContents` ni existe (los nombres cambian entre versiones y el
    // parche se queda mudo sin avisar). Se vigila el propio carrito en
    // pantalla: cuando Dawn lo repinta, se relee la cesta. Funciona con
    // cualquier versión y con cualquier cosa que toque el carrito.
    var lista = document.getElementById('main-cart-items');
    if (lista && window.MutationObserver) {
      var espera = null;
      new MutationObserver(function () {
        window.clearTimeout(espera);
        espera = window.setTimeout(function () {
          fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (x) { return x.json(); })
            .then(function (c) { cestaTrasCambio(c); })
            .catch(function () {});
        }, 250);
      }).observe(lista, { childList: true, subtree: true });
    }
  }

  function initCesta() {
    var caja = document.querySelector('[data-cd-cesta]');
    if (!caja) return;

    var panel  = caja.querySelector('[data-cd-cesta-panel]');
    var linea  = caja.querySelector('[data-cd-cesta-linea]');
    var recos  = caja.querySelector('[data-cd-cesta-recos]');
    var pista  = recos ? recos.querySelector('[data-cd-recos-pista]') : null;
    var previo = null;

    function abre() {
      previo = document.activeElement;
      caja.hidden = false;
      caja.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      // Se fuerza un recálculo y se pone la clase. Con requestAnimationFrame
      // no valía: el navegador lo congela en pestañas en segundo plano y el
      // aviso se quedaba sin abrir, invisible pero con el velo puesto.
      void caja.offsetHeight;
      caja.classList.add('is-abierta');
      // Las tarjetas se pintan ANTES de abrir para que no dé el salto, pero con
      // el panel oculto el carril mide cero de ancho y las flechas salían las
      // dos apagadas. Ya visible, se vuelve a medir.
      var z = caja.querySelector('[data-cd-recos-zona]');
      if (z && z.__cdActualiza) z.__cdActualiza();
      if (panel) panel.focus();
    }

    function cierra() {
      /* Si había un «Pagar» retenido esperando al regalo, cerrar el aviso lo
         anula. Antes no: el cliente pulsaba Pagar, se arrepentía, cerraba el
         panel... y a los 3 s el temporizador soltaba el clic igual y la tienda
         se lo llevaba al pago. Reproducido en navegador real contra el fichero
         que sirve la tienda. 9 sept 2026.                                   */
      if (regaloPagoPendiente) { try { regaloPagoPendiente(); } catch (err) {} }
      caja.classList.remove('is-abierta');
      caja.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      var fin = function () { caja.hidden = true; };
      if (menosMovimiento) { fin(); } else { window.setTimeout(fin, 420); }
      if (previo && previo.focus) previo.focus();
    }

    caja.addEventListener('click', function (e) {
      if (e.target.closest('[data-cd-cesta-cerrar]')) { e.preventDefault(); cierra(); }
    });
    document.addEventListener('keydown', function (e) {
      if (caja.hidden || caja.getAttribute('aria-hidden') === 'true') return;
      if (e.key === 'Escape') { e.preventDefault(); cierra(); }
      if (e.key === 'Tab') {
        var items = Array.from(panel.querySelectorAll('button, a[href], input, [tabindex="0"]'))
          .filter(function (el) { return !el.disabled && el.getClientRects().length; });
        var primero = items[0], ultimo = items[items.length - 1];
        if (e.shiftKey && (document.activeElement === primero || document.activeElement === panel)) {
          e.preventDefault(); ultimo.focus();
        } else if (!e.shiftKey && document.activeElement === ultimo) {
          e.preventDefault(); primero.focus();
        }
      }
    });

    /* Pinta la línea del producto recién añadido con lo que devuelve la
       propia respuesta de Shopify: nada escrito a mano. */
    function pintaLinea(art) {
      if (!linea) return;
      var foto = art.image
        ? '<div class="cd-cesta__foto"><img src="' + art.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') +
          '" alt="" width="66" height="66"></div>'
        : '';
      var meta = [];
      if (art.quantity > 1) meta.push(art.quantity + ' uds.');
      if (art.variant_title && art.variant_title !== 'Default Title') meta.push(art.variant_title);

      linea.innerHTML =
        foto +
        '<div class="cd-cesta__datos">' +
          '<p class="cd-cesta__n">' + (art.product_title || art.title || '') + '</p>' +
          (meta.length ? '<p class="cd-cesta__meta">' + meta.join(' · ') + '</p>' : '') +
        '</div>' +
        '<span class="cd-cesta__precio">' + cestaDinero(art.final_line_price != null ? art.final_line_price : art.line_price) + '</span>';
    }

    /* 3 nov 2026 · recuadro de la cesta: el camión con la fecha de la ficha (tal cual, con las fechas en verde) y, desde 50 €, los 3 plazos
       de Klarna. El aviso solo se abre desde la ficha, así que la fecha es la del producto que se acaba de añadir. Si algo falla
       aquí, el recuadro se queda oculto y el aviso sale igual. */
    function pintaClaves(c) {
      var tarj = caja.querySelector('[data-cd-cesta-claves]');
      if (!tarj) return;
      try {
        var llega = tarj.querySelector('[data-cd-cesta-llega]');
        var pago = tarj.querySelector('[data-cd-cesta-pago]');
        var fecha = document.querySelector('[data-cd2-entrega] [data-cd2-entrega-txt]');
        var hay = !!(fecha && /lo recibes/i.test(fecha.textContent || ''));
        if (llega) {
          llega.hidden = !hay;
          if (hay) llega.querySelector('.cd2-entrega__txt').innerHTML = fecha.innerHTML;
        }
        if (pago) {
          var total = (c && c.total_price) || 0;
          pago.hidden = total < 5000;
          if (total >= 5000) pago.textContent = 'O en 3 plazos de ' + cestaDinero(Math.ceil(total / 3)) + ' sin intereses con Klarna.';
        }
        tarj.hidden = false;
      } catch (err) { tarj.hidden = true; }
    }

    /* Las recomendaciones se piden NADA MÁS CARGAR la ficha, no al añadir.
       Así el aviso se abre con todo dentro de una vez. Antes se abría primero
       y las tarjetas caían medio segundo después: el panel crecía por debajo
       y se veía cargar por cachos. */
    var recosPedidas = null;
    var recosFuera = {};

    function pidePronto() {
      var f = document.querySelector('[data-cd-form]');
      var id = f && f.getAttribute('data-cd-producto');
      if (!id || recosPedidas) return;
      recosPedidas = cestaRecomienda(id, 8, true);   // 23 oct 2026: 8, como en las fichas (antes 3)
    }

    function pintaRecos() {
      if (!recos || !pista || !recosPedidas) return Promise.resolve();
      return recosPedidas.then(function (tarjetas) {
        tarjetas = tarjetas.filter(function (t) { return !recosFuera[String(t.getAttribute('data-producto-id'))]; });
        pista.innerHTML = '';
        if (!tarjetas.length) { recos.hidden = true; return; }
        tarjetas.forEach(function (t) { pista.appendChild(t.cloneNode(true)); });
        var tit = recos.querySelector('.cd-cesta__recos-t');
        if (tit) {
          if (!tit.__cdNormal) tit.__cdNormal = tit.textContent;
          var conDto = tarjetas.find(function (t) { return t.getAttribute('data-cd-reco-dto'); });
          tit.textContent = conDto ? (conDto.getAttribute('data-cd-reco-titulo') || tit.__cdNormal) : tit.__cdNormal;
        }
        recos.hidden = false;
        cestaCarril(recos.querySelector('[data-cd-recos-zona]'));
      }).catch(function () { /* sin recomendaciones, el aviso sale igual */ });
    }

    /* Añade y abre el aviso. Devuelve false si no ha podido, para que quien
       llame decida si deja pasar el envío normal del formulario.           */
    function anade(cuerpo, principal) {
      var cabeceras = { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
      // Con «tu segundo producto» marcado se mandan varios artículos en JSON.
      if (typeof cuerpo === 'string') cabeceras['Content-Type'] = 'application/json';
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: cabeceras,
        body: cuerpo
      })
        .then(function (r) {
          /* 12 oct 2026 · 422 = Shopify dice que no hay (agotado, o no quedan tantas unidades). Antes caía
             en el envío normal del formulario, que SÍ lo metía en la cesta, y la clienta no se enteraba
             hasta el pago (pasó con el bálsamo a 0). Ahora se para aquí y se le dice (sinStock). */
          if (r.status === 422) {
            return r.json().catch(function () { return {}; }).then(function (j) {
              var e = new Error('sin-stock');
              e.sinStock = true;
              e.mensaje = (j && (j.description || j.message)) || '';
              throw e;
            });
          }
          if (!r.ok) throw new Error('add');
          return r.json();
        })
        .then(function (res) {
          var varios = res.items || [];
          var art = varios.find(function (i) { return principal && String(i.variant_id) === String(principal); }) || varios[0] || res;
          pintaLinea(art);
          var otros = varios.filter(function (i) { return i !== art; }).map(function (i) { return i.product_title || i.title; });
          if (otros.length && linea) {
            var y = document.createElement('p');
            y.className = 'cd-cesta__meta cd-cesta__tambien';
            y.textContent = 'Y también: ' + otros.join(' · ');
            var datos = linea.querySelector('.cd-cesta__datos');
            (datos || linea).appendChild(y);
          }
          // Se abre DESPUÉS de tener las recomendaciones puestas, para que el
          // panel salga ya a su tamaño final y no dé el salto. Normalmente ya
          // están pedidas desde que cargó la página, así que no se espera nada.
          return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
            .then(function (c) {
              cestaTrasCambio(c);
              pintaClaves(c);
              // Lo que ya está en la cesta no se vuelve a sugerir (las tarjetas se
              // pidieron al cargar la ficha, antes de añadir el segundo producto).
              recosFuera = {};
              (c.items || []).forEach(function (i) { recosFuera[String(i.product_id)] = true; });
            })
            .then(pintaRecos)
            .then(function () { abre(); return true; })
            .catch(function () { window.location.href = '/cart'; return true; });
        });
    }

    /* Se pide cuando el navegador está ocioso para no competir con la carga
       de la propia ficha (las fotos mandan). Si no hay requestIdleCallback,
       un respiro y listo. */
    if (window.requestIdleCallback) {
      requestIdleCallback(pidePronto, { timeout: 2500 });
    } else {
      window.setTimeout(pidePronto, 1200);
    }

    /* --- El formulario de la ficha --------------------------------------- */
    var form = document.querySelector('[data-cd-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) return;   // navegador viejo: envío normal
        e.preventDefault();
        var boton = form.querySelector('[data-cd-anadir]');
        if (boton) boton.setAttribute('aria-busy', 'true');
        var extras = Array.prototype.slice.call(form.querySelectorAll('[data-cd-segundo] [data-cd-segundo-op]:checked, [data-cd-extra-op]:checked:not([data-cd-extra-en-pack])'));
        var cuerpo = new FormData(form), principal = null;
        if (extras.length) {
          var idCampo = form.querySelector('input[name="id"]');
          var cantCampo = form.querySelector('[data-cd-cantidad]');
          principal = idCampo ? idCampo.value : null;
          cuerpo = JSON.stringify({ items: [{ id: Number(principal), quantity: Number((cantCampo && cantCampo.value) || 1) }]
            .concat(extras.map(function (c) { return { id: Number(c.value), quantity: 1 }; })) });
        }
        anade(cuerpo, principal)
          .catch(function (err) {
            if (err && err.sinStock) { sinStock(err.mensaje); return; }
            form.submit();                                 // si falla, como toda la vida
          })
          .then(function () { if (boton) boton.removeAttribute('aria-busy'); });
      });

      /* 12 oct 2026 · Shopify no deja añadirlo: se dice debajo del botón con su propio mensaje
         («… ya está agotado», «Solo puedes añadir…»). Y si la variante se ha quedado sin nada mientras
         la página estaba abierta, el botón y la barra fija pasan a «Agotado», como si hubiera cargado ya así. */
      var sinStock = function (mensaje) {
        var boton = form.querySelector('[data-cd-anadir]');
        var aviso = form.querySelector('[data-cd-sin-stock]');
        if (!aviso && boton) {
          aviso = document.createElement('p');
          aviso.className = 'cd2-ficha__sin-stock';
          aviso.setAttribute('data-cd-sin-stock', '');
          aviso.setAttribute('role', 'alert');
          boton.insertAdjacentElement('afterend', aviso);
        }
        if (aviso) aviso.textContent = mensaje || 'No quedan tantas unidades.';
        var url = form.getAttribute('data-cd-product-url');
        var campoId = form.querySelector('input[name="id"]');
        if (!url || !campoId || !boton) return;
        fetch(url + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (pr) {
            var va = (pr.variants || []).filter(function (x) { return String(x.id) === String(campoId.value); })[0];
            if (!va || va.available) return;
            [boton, document.querySelector('[data-cd-barra-btn]')].forEach(function (b) {
              if (!b) return;
              b.disabled = true;
              b.textContent = boton.getAttribute('data-cd-agotado') || 'Agotado';
            });
          })
          .catch(function () {});
      };
    }

    /* --- Los botones "Añadir" de CUALQUIER tarjeta -----------------------
       Portada, filas, catálogo, recomendados y los de dentro del aviso: todos
       usan el mismo botón y el mismo camino.

       Desde una tarjeta NO se abre el aviso grande ni se lleva a la cesta:
       quien está mirando una lista quiere seguir mirándola. Sale el aviso
       pequeño de arriba a la derecha y se queda donde estaba.

       Ninguno de los once productos tiene variantes de verdad (comprobado el
       30 ago 2026), así que no hace falta ningún panel para elegir.          */
    /* UNA sola vez. Sin esto, en el editor cada recarga de sección dejaba otro
       escuchador y el botón «Añadir» de una tarjeta metía dos o tres unidades
       de golpe. Es el único de estos duplicados con un síntoma que se ve. */
    if (document.__cdAnadirRapido) return;
    document.__cdAnadirRapido = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cd-anadir-rapido]');
      if (!b || !window.fetch) return;
      e.preventDefault();
      // Y que no siga subiendo: la tarjeta entera es un enlace a la ficha.
      e.stopPropagation();
      var id = b.getAttribute('data-cd-anadir-rapido');
      if (!id || b.disabled) return;

      var enCarrito = window.location.pathname.indexOf('/cart') === 0;
      var antes = b.textContent;
      b.disabled = true;
      b.textContent = '…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) { var e = new Error('add'); e.estado = r.status; throw e; }
          return r.json();
        })
        .then(function () {
          // En la página del carrito hay que recargar o los totales mienten.
          if (enCarrito) { window.location.reload(); return; }
          b.disabled = false;
          b.textContent = antes;
          cestaAvisaRapido(b.getAttribute('data-nombre') || '');
          return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) { return r.json(); })
            .then(function (c) { cestaTrasCambio(c); });
        })
        .catch(function (err) {
          /* 12 oct 2026 · 422: agotado (o no quedan más). La vía de siempre (/cart/add?id=…) lo metía en
             la cesta igual; ahora el botón se queda en «Agotado», desactivado. */
          if (err && err.estado === 422) {
            b.textContent = 'Agotado';
            b.classList.add('cd-anadir--agotado');
            return;
          }
          // Si falla, se hace por la vía de siempre en vez de dejarlo colgado.
          b.disabled = false;
          b.textContent = antes;
          window.location.href = '/cart/add?id=' + id + '&quantity=1';
        });
    });
  }

  /* --- La fila de recomendaciones de la PÁGINA de la cesta ----------------
     El servidor la pinta con la colección de respaldo, así que se ve aunque
     el JS no llegue. Aquí se mejora con las recomendaciones de verdad del
     primer artículo de la cesta.                                           */
  function initRecosCesta() {
    var fila = document.querySelector('[data-cd-recos]');
    if (!fila || !window.fetch) return;
    var pista = fila.querySelector('[data-cd-recos-pista]');
    if (!pista) return;
    var limite = parseInt(fila.getAttribute('data-limite'), 10) || 8;

    // Las flechas se atan ya, con las tarjetas de respaldo que pintó el
    // servidor: si el JS de recomendaciones tarda o falla, siguen funcionando.
    cestaCarril(fila.querySelector('[data-cd-recos-zona]'));

    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c.items || !c.items.length) return;
        return cestaRecomienda(c.items[0].product_id, limite, true).then(function (tarjetas) {
          if (tarjetas.length < 2) return;   // con una sola no merece la pena tocar nada
          pista.innerHTML = '';
          tarjetas.forEach(function (t) { pista.appendChild(t); });
          /* 8 oct 2026 · Si las tarjetas llevan la rebaja de «llévate otro», el título lo dice (como en el aviso). */
          var tit = fila.querySelector('.cd-recos__t');
          var conDto = tarjetas.find(function (t) { return t.getAttribute('data-cd-reco-dto'); });
          if (tit && conDto) tit.textContent = conDto.getAttribute('data-cd-reco-titulo') || tit.textContent;
          cestaCarril(fila.querySelector('[data-cd-recos-zona]'));
        });
      })
      .catch(function () { /* se queda la de respaldo, que ya está pintada */ });
  }

  /* --- Pase de fotos en las tarjetas (20 sept 2026) -----------------------
     El carril es desplazamiento nativo. Aquí solo las flechas y los puntos, con
     escuchadores en el documento para que valgan también para las tarjetas que
     llegan después (filtros de la colección, recomendaciones de la cesta).    */
  function initFotosTarjeta() {
    if (document.__cdFotosTarjeta) return;
    document.__cdFotosTarjeta = true;

    function pinta(caja) {
      var pista = caja.querySelector('[data-cd-fotos-pista]');
      if (!pista) return;
      var ancho = pista.clientWidth || 1;
      var total = pista.children.length;
      var i = Math.max(0, Math.min(total - 1, Math.round(pista.scrollLeft / ancho)));
      var puntos = caja.querySelectorAll('[data-cd-fotos-puntos] i');
      puntos.forEach(function (p, n) { p.classList.toggle('is-activa', n === i); });
      var ant = caja.querySelector('[data-cd-fotos-ant]');
      var sig = caja.querySelector('[data-cd-fotos-sig]');
      if (ant) ant.disabled = i <= 0;
      if (sig) sig.disabled = i >= total - 1;
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-cd-fotos-ant], [data-cd-fotos-sig]') : null;
      if (!b) return;
      // La flecha vive dentro de una tarjeta que es toda ella un enlace: que no navegue.
      e.preventDefault();
      e.stopPropagation();
      var caja = b.closest('[data-cd-fotos]');
      var pista = caja && caja.querySelector('[data-cd-fotos-pista]');
      if (!pista) return;
      var dir = b.hasAttribute('data-cd-fotos-sig') ? 1 : -1;
      var ancho = pista.clientWidth || 1;
      var i = Math.round(pista.scrollLeft / ancho) + dir;
      var destino = Math.max(0, Math.min(pista.children.length - 1, i)) * ancho;
      if (pista.scrollTo) pista.scrollTo({ left: destino, behavior: menosMovimiento ? 'auto' : 'smooth' });
      else pista.scrollLeft = destino;
      // El desplazamiento suave no siempre arranca (pestaña en segundo plano, ahorro de batería,
      // carril con el desbordamiento oculto): si a medio segundo no ha llegado, se coloca a mano.
      window.setTimeout(function () {
        if (Math.abs(pista.scrollLeft - destino) > 2) pista.scrollLeft = destino;
        pinta(caja);
      }, 520);
    }, true);

    // `scroll` no burbujea: se escucha en captura.
    var pendiente = null;
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (!t || !t.hasAttribute || !t.hasAttribute('data-cd-fotos-pista')) return;
      if (pendiente) return;
      pendiente = window.requestAnimationFrame(function () {
        pendiente = null;
        var caja = t.closest('[data-cd-fotos]');
        if (caja) pinta(caja);
      });
    }, true);
  }

  /* Barra de arriba: carrusel que avanza solo, y que se calla mientras el
     cliente lo mueve con el dedo. El primer pintado lo hace Liquid, así que
     con el JS apagado se ve la primera frase y se pueden pasar las demás
     deslizando igualmente: el desplazamiento es nativo.                    */
  function initAvisoGira() {
    document.querySelectorAll('[data-cd-aviso]').forEach(function (caja) {
      if (caja.__cdGirando) return;
      var frases = caja.querySelectorAll('.cd-aviso__f');
      if (frases.length < 2) return;
      caja.__cdGirando = true;

      var seg = Math.max(2, Number(caja.getAttribute('data-giro')) || 4);
      var pausaHasta = 0;
      var pausaManual = menosMovimiento;
      var control = caja.parentNode.querySelector('[data-cd-aviso-pausa]');
      function pintaPausa() {
        if (!control) return;
        control.setAttribute('aria-pressed', String(pausaManual));
        control.setAttribute('aria-label', control.getAttribute(pausaManual ? 'data-play' : 'data-pause'));
        control.querySelector('span').textContent = pausaManual ? '▶' : 'Ⅱ';
      }
      if (control) control.addEventListener('click', function () { pausaManual = !pausaManual; pintaPausa(); });
      pintaPausa();

      // Si lo está tocando, mandan sus dedos: 7 s sin avanzar solo.
      function manda() { pausaHasta = Date.now() + 7000; }
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
        caja.addEventListener(ev, manda, { passive: true });
      });

      window.setInterval(function () {
        if (document.hidden) return;          // pestaña de fondo: ni gastar
        if (pausaManual || Date.now() < pausaHasta) return;  // lo está moviendo él
        var ancho = caja.clientWidth || 1;
        // Solo cuentan las frases que se ven (las de móvil y las de ordenador
        // conviven en el HTML y el CSS esconde unas u otras).
        var visibles = 0;
        for (var k = 0; k < frases.length; k++) { if (frases[k].offsetWidth > 0) visibles++; }
        if (visibles < 2) return;
        var i = Math.round(caja.scrollLeft / ancho);
        i = (i + 1) % visibles;
        try {
          caja.scrollTo({ left: i * ancho, behavior: 'smooth' });
        } catch (e) {
          caja.scrollLeft = i * ancho;        // navegadores viejos
        }
      }, seg * 1000);
    });
  }

  /* CADA ENCARGO EN SU PROPIA RED, y esto no es manía.

     Antes esto eran 23 llamadas en fila. La primera que fallara paraba el
     javascript ahí y las siguientes NO se ejecutaban — sin aviso para el
     cliente y sin nada en pantalla que lo delatara.

     Y lo que hay en juego no es poco: la portada NACE INVISIBLE a propósito
     (`.cd-reveal { opacity: 0 }` en cd-styles.css) y quien la destapa es
     `initReveals`, la TERCERA de la lista. O sea que un fallo en una animación
     decorativa dejaba la portada en blanco. De la 20 en adelante está el
     bálsamo de regalo, y en medio el carrito entero.

     El 8 sept 2026 pasó dos veces en el mismo día. Así que ahora un fallo se
     come SOLO su trozo, y además deja escrito en la consola cuál fue.       */
  function arranca() {
    var encargos = [
      initLineas, initStagger, initReveals, initParallax, initHeader,
      initAvisoGira, initRegaloBotones, initTonos, initEscena, initAcordeones,
      initCifras, initGaleria, initPacks, initCompraSimple, initResenas, initCupon,
      initBarraCompra, initBarraHero, initArregloCarritoDawn, initAvisoRapido, initFotosTarjeta,
      function escuchadores() {
        // Con bandera: el editor de temas vuelve a llamar a arranca() en cada
        // recarga de seccion y si no, se duplicarian los escuchadores.
        if (document.__cdEscuchadores) return;
        document.__cdEscuchadores = true;
        window.addEventListener('pageshow', regaloAlVolver);
        document.addEventListener('click', regaloAntesDePagar, true);
      },
      cestaSincronizaCuenta,   // revisa el regalo tambien al cargar
      cestaRefrescaEnvio,
      initCesta,
      initRecosCesta
    ];

    encargos.forEach(function (f) {
      try {
        f();
      } catch (e) {
        if (window.console && console.error) {
          console.error('[cd] falló ' + (f.name || 'un encargo sin nombre') +
                        ' — el resto de la tienda sigue funcionando', e);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }

  // El editor de Shopify recarga secciones sueltas: re-inicializa
  document.addEventListener('shopify:section:load', arranca);
})();
